export const images = [
  require("assets/god/objects/0.png"),
  require("assets/god/objects/1.png"),
  require("assets/god/objects/2.png"),
  require("assets/god/objects/3.png"),
  require("assets/god/objects/4.png"),
  require("assets/god/objects/5.png"),
  require("assets/god/objects/6.png"),
  require("assets/god/objects/7.png"),
  require("assets/god/objects/8.png"),
  require("assets/god/objects/9.png"),
  require("assets/god/objects/10.png"),
  require("assets/god/objects/11.png"),
  require("assets/god/objects/12.png"),
  require("assets/god/objects/13.png"),
  require("assets/god/objects/14.png"),
  require("assets/god/objects/15.png"),
  require("assets/god/objects/16.png"),
  require("assets/god/objects/17.png"),
  require("assets/god/objects/18.png"),
  require("assets/god/objects/19.png"),
  require("assets/god/objects/20.png"),
  require("assets/god/objects/21.png"),
  require("assets/god/objects/22.png"),
  require("assets/god/objects/23.png"),
  require("assets/god/objects/24.png"),
  require("assets/god/objects/25.png"),
  require("assets/god/objects/26.png"),
  require("assets/god/objects/27.png"),
  require("assets/god/objects/28.png"),
  require("assets/god/objects/29.png"),
  require("assets/god/objects/30.png"),
  require("assets/god/objects/31.png"),
  require("assets/god/objects/32.png"),
  require("assets/god/objects/33.png"),
  require("assets/god/objects/34.png"),
  require("assets/god/objects/35.png"),
  require("assets/god/objects/36.png"),
  require("assets/god/objects/37.png"),
  require("assets/god/objects/38.png"),
  require("assets/god/objects/39.png"),
  require("assets/god/objects/40.png"),
  require("assets/god/objects/41.png"),
  require("assets/god/objects/42.png"),
  require("assets/god/objects/43.png"),
  require("assets/god/objects/44.png"),
  require("assets/god/objects/45.png"),
  require("assets/god/objects/46.png"),
  require("assets/god/objects/47.png"),
  require("assets/god/objects/48.png"),
  require("assets/god/objects/49.png"),
  require("assets/god/objects/50.png"),
  require("assets/god/objects/51.png"),
  require("assets/god/objects/52.png"),
  require("assets/god/objects/53.png"),
  require("assets/god/objects/54.png"),
  require("assets/god/objects/55.png"),
  require("assets/god/objects/56.png"),
  require("assets/god/objects/57.png"),
  require("assets/god/objects/58.png"),
  require("assets/god/objects/59.png"),
  require("assets/god/objects/60.png"),
  require("assets/god/objects/61.png"),
  require("assets/god/objects/62.png"),
  require("assets/god/objects/63.png"),
  require("assets/god/objects/64.png"),
  require("assets/god/objects/65.png"),
  require("assets/god/objects/66.png"),
  require("assets/god/objects/67.png"),
  require("assets/god/objects/68.png"),
  require("assets/god/objects/69.png"),
  require("assets/god/objects/70.png"),
  require("assets/god/objects/71.png"),
  require("assets/god/objects/72.png"),
  require("assets/god/objects/73.png"),
  require("assets/god/objects/74.png"),
  require("assets/god/objects/75.png"),
  require("assets/god/objects/76.png"),
  require("assets/god/objects/77.png"),
  require("assets/god/objects/78.png"),
  require("assets/god/objects/79.png"),
  require("assets/god/objects/80.png"),
  require("assets/god/objects/81.png"),
  require("assets/god/objects/82.png"),
  require("assets/god/objects/83.png"),
  require("assets/god/objects/84.png"),
  require("assets/god/objects/85.png"),
  require("assets/god/objects/86.png"),
  require("assets/god/objects/87.png"),
  require("assets/god/objects/88.png"),
  require("assets/god/objects/89.png"),
  require("assets/god/objects/90.png"),
  require("assets/god/objects/91.png"),
  require("assets/god/objects/92.png"),
  require("assets/god/objects/93.png"),
  require("assets/god/objects/94.png"),
  require("assets/god/objects/95.png"),
  require("assets/god/objects/96.png"),
  require("assets/god/objects/97.png"),
  require("assets/god/objects/98.png"),
  require("assets/god/objects/99.png"),
  require("assets/god/objects/100.png"),
  require("assets/god/objects/101.png"),
  require("assets/god/objects/102.png"),
  require("assets/god/objects/103.png"),
  require("assets/god/objects/104.png"),
  require("assets/god/objects/105.png"),
  require("assets/god/objects/106.png"),
  require("assets/god/objects/107.png"),
  require("assets/god/objects/108.png"),
  require("assets/god/objects/109.png"),
  require("assets/god/objects/110.png"),
  require("assets/god/objects/111.png"),
  require("assets/god/objects/112.png"),
  require("assets/god/objects/113.png"),
  require("assets/god/objects/114.png"),
  require("assets/god/objects/115.png"),
  require("assets/god/objects/116.png"),
  require("assets/god/objects/117.png"),
  require("assets/god/objects/118.png"),
  require("assets/god/objects/119.png"),
  require("assets/god/objects/120.png"),
  require("assets/god/objects/121.png"),
  require("assets/god/objects/122.png"),
  require("assets/god/objects/123.png"),
  require("assets/god/objects/124.png"),
  require("assets/god/objects/125.png"),
  require("assets/god/objects/126.png"),
  require("assets/god/objects/127.png"),
  require("assets/god/objects/128.png"),
  require("assets/god/objects/129.png"),
  require("assets/god/objects/130.png"),
  require("assets/god/objects/131.png"),
  require("assets/god/objects/132.png"),
  require("assets/god/objects/133.png"),
  require("assets/god/objects/134.png"),
  require("assets/god/objects/135.png"),
  require("assets/god/objects/136.png"),
  require("assets/god/objects/137.png"),
  require("assets/god/objects/138.png"),
  require("assets/god/objects/139.png"),
  require("assets/god/objects/140.png"),
  require("assets/god/objects/141.png"),
  require("assets/god/objects/142.png"),
  require("assets/god/objects/143.png"),
  require("assets/god/objects/144.png"),
  require("assets/god/objects/145.png"),
  require("assets/god/objects/146.png"),
  require("assets/god/objects/147.png"),
  require("assets/god/objects/148.png"),
  require("assets/god/objects/149.png"),
  require("assets/god/objects/150.png"),
  require("assets/god/objects/151.png"),
];

export const objects = [{
    "label": "NGC 6523",
    "name": "Lagoon Nebula",
    "type": "Emission Nebula",
    "constellation": "Sagittarius",
    "magnitude": 6,
    "credit": "NASA/ESA/STScI",
    "img": 62,
    "ra": {
      "decimal": 270.9042,
      "h": 18,
      "m": 3,
      "s": 37
    },
    "dec": {
      "decimal": -24.3867,
      "d": -24,
      "m": 23,
      "s": 12
    },
    "description": "The Lagoon Nebula (catalogued as Messier 8 or M8, NGC 6523, Sharpless 25, RCW 146, and Gum 72) is a giant interstellar cloud in the constellation Sagittarius. It is classified as an emission nebula and as an H II region.\nThe Lagoon Nebula was discovered by Giovanni Hodierna before 1654 and is one of only two star-forming nebulae faintly visible to the eye from mid-northern latitudes. Seen with binoculars, it appears as a distinct cloud-like patch with a definite core. Within the nebula is the open cluster NGC 6530.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "IC 417",
    "name": "Spider Nebula",
    "type": "Emission Nebula",
    "constellation": "Auriga",
    "magnitude": 5,
    "credit": "NASA/JPL-Caltech",
    "img": 0,
    "ra": {
      "decimal": 82.0125,
      "h": 5,
      "m": 28,
      "s": 3
    },
    "dec": {
      "decimal": 34.41166666666666,
      "d": 34,
      "m": 24,
      "s": 42
    },
    "desccred": "https://nasa.gov/",
    "description": "The spider part of \"The Spider and the Fly\" nebulae, IC 417 abounds in star formation, as seen in this infrared image from NASA's Spitzer Space Telescope and the Two Micron All Sky Survey (2MASS).\n\nLocated in the constellation Auriga, IC 417 lies about 10,000 light-years away. It is in the outer part of the Milky Way, almost exactly in the opposite direction from the galactic center. This region was chosen as the subject of a research project by a group of students, teachers and scientists as part of the NASA/IPAC Teacher Archive Research Program (NITARP) in 2015.\n\nA cluster of young stars called \"Stock 8\" can be seen at center right. The light from this cluster carves out a bowl in the nearby dust clouds, seen here as green fluff. Along the sinuous tail in the center and to the left, groupings of red point sources are also young stars."
  },
  {
    "label": "ESO 378-1",
    "name": "Southern Owl Nebula",
    "type": "Planetary Nebula",
    "constellation": "Hydra",
    "magnitude": 17.4,
    "credit": "ESO",
    "img": 2,
    "ra": {
      "decimal": 171.68236301987457,
      "h": 11,
      "m": 26,
      "s": 43.7671247699
    },
    "dec": {
      "decimal": -34.36977188071111,
      "d": -34,
      "m": 22,
      "s": 11.17877056
    },
    "description": "The Southern Owl Nebula (PLN 283+25.1, ESO 378-1) is a planetary nebula located in the constellation Hydra. The nebula lies at a distance of 2,030 light years from Earth.\nIt is named so because of its resemblance to the Owl Nebula in Ursa Major. The nebula is notably symmetric, round, and has a diameter of approximately four light-years across.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "IC 2944",
    "name": "Running Chicken Nebula",
    "type": "Emission Nebula",
    "constellation": "Centaurus",
    "magnitude": 4.5,
    "credit": "NASA/JPL-Caltech/UCLA",
    "img": 3,
    "ra": {
      "decimal": 174.58333333333334,
      "h": 11,
      "m": 38,
      "s": 20
    },
    "dec": {
      "decimal": -63.37277777777778,
      "d": -63,
      "m": 22,
      "s": 22
    },
    "description": "IC 2944, also known as the Running Chicken Nebula , the Lambda Centauri Nebula or the λ Centauri Nebula, is an open cluster with an associated emission nebula found in the constellation Centaurus, near the star λ Centauri. It features Bok globules, which are frequently a site of active star formation.  However, no evidence for star formation has been found in any of the globules in IC 2944. Other designations for IC 2944 include RCW 62, G40 and G42.The ESO Very Large Telescope image on the right is a close up of a set of Bok globules discovered in IC 2944 by astronomer A. David Thackeray in 1950. These globules are now known as Thackeray's Globules. In 2MASS images, 6 stars are visible within the largest globule.\nThe region of nebulosity visible in modern images includes both IC 2944 and IC 2948, as well as the fainter IC 2872 nearby. IC 2948 is the brightest emission and reflection nebulae towards the southeast, while IC 2944 is the cluster of stars and surrounding nebulosity stretching towards λ Centauri. IC 2944 gets the running chicken nebula name from a group of stars that resemble a running chicken. The star Lambda Centauri lies just outside IC 2944. The nebulae is 6,500 light years from earth.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "IRAS 05437+2502",
    "name": "Iras Ghost Nebula",
    "type": "Reflection Nebula",
    "constellation": "Taurus",
    "magnitude": 2,
    "credit": "NASA/ESA/Hubble",
    "img": 4,
    "ra": {
      "decimal": 86.714537,
      "h": 5,
      "m": 46,
      "s": 51.48888
    },
    "dec": {
      "decimal": 25.063219,
      "d": 25,
      "m": 3,
      "s": 47.5884
    },
    "description": "IRAS 05437+2502 is a reflection nebula in the constellation Taurus.\n\nAstronomers think that a young star coming from the nebula could have been traveling at 124,000 mph and may of caused its distinctive \"boomerang\" shape when it passed through.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "Sh2-106",
    "name": "Snow Angel Nebula",
    "type": "Emission Nebula",
    "constellation": "Cygnus",
    "magnitude": 14.5,
    "credit": "NASA/ESA/Hubble",
    "img": 5,
    "ra": {
      "decimal": 306.8616666666667,
      "h": 20,
      "m": 27,
      "s": 26.8
    },
    "dec": {
      "decimal": 37.38027777777778,
      "d": 37,
      "m": 22,
      "s": 49
    },
    "description": "Sh2-106 is an emission nebula and a star formation region in the constellation Cygnus.  It is a H II region estimated to be around 2,000 ly (600 pc) from Earth, in an isolated area of the Milky WayIn the center of the nebula is a young and massive star that emits jets of hot gas from its poles, forming the bipolar structure.  Dust surrounding the star is also ionized by the star.  The nebula spans about 2 light-years across.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "Mz 3",
    "name": "Ant Nebula",
    "type": "Planetary Nebula",
    "constellation": "Norma",
    "magnitude": 13.8,
    "credit": "NASA/ESA/Hubble",
    "img": 6,
    "ra": {
      "decimal": 244.30579807604,
      "h": 16,
      "m": 17,
      "s": 13.3915382496
    },
    "dec": {
      "decimal": -51.9863088593,
      "d": -51,
      "m": 59,
      "s": 10.71189348
    },
    "description": "Mz 3 (Menzel 3) is a young bipolar planetary nebula (PN) in the constellation Norma that is composed of a bright core and four distinct high-velocity outflows that have been named lobes, columns, rays, and chakram.  These nebulosities are described as: two spherical bipolar lobes, two outer large filamentary hour-glass shaped columns, two cone shaped rays, and a planar radially expanding, elliptically shaped chakram.\nMz 3 is a complex system composed of three nested pairs of bipolar lobes and an equatorial ellipse.\nIts lobes all share the same axis of symmetry but each have very different morphologies and opening angles.\nIt is an unusual PN in that it is believed, by some researchers, to contain a symbiotic binary at its center.\nOne study suggests that the dense nebular gas at its center may have originated from a source different from that of its extended lobes.   The working model to explain this hypothesizes that this PN is composed of a giant companion that caused a central dense gas region to form, and a white dwarf that provides ionizing photons for the PN.Mz 3 is often referred to as the Ant Nebula because it resembles the head and thorax of a garden-variety ant.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "Sh2-276",
    "name": "Barnard's Loop",
    "type": "Emission Nebula",
    "constellation": "Orion",
    "magnitude": 5,
    "credit": "Public Domain",
    "img": 7,
    "ra": {
      "decimal": 81.875,
      "h": 5,
      "m": 27,
      "s": 30
    },
    "dec": {
      "decimal": -3.966666666666667,
      "d": -3,
      "m": 58,
      "s": 0
    },
    "description": "Barnard's Loop (catalogue designation Sh2-276) is an emission nebula in the constellation of Orion.  It is part of the Orion molecular cloud complex which also contains the dark Horsehead and bright Orion nebulae.  The loop takes the form of a large arc centered approximately on the Orion Nebula.  The stars within the Orion Nebula are believed to be responsible for ionizing the loop.\nThe loop extends over about 600 arcminutes as seen from Earth, covering much of Orion.  It is well seen in long-exposure photographs, although observers under very dark skies may be able to see it with the naked eye.\nRecent estimates place it at a distance of either 159 pc (518 light years) or 440 pc (1434 ly) giving it dimensions of either about 100 or 300 ly across respectively. It is thought to have originated in a supernova explosion about 2 million years ago, which may have also created several known runaway stars, including AE Aurigae, Mu Columbae and 53 Arietis, which are believed to have been part of a multiple star system in which one component exploded as a supernova.Although this faint nebula was certainly observed by earlier astronomers, it is named after the pioneering astrophotographer E. E. Barnard who photographed it and published a description in 1894.\n\n\t\t\n\t\t\n\n",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 6995",
    "name": "Bat Nebula",
    "type": "Supernova Remnant",
    "constellation": "Cygnus",
    "magnitude": 7,
    "credit": "Public Domain",
    "img": 8,
    "ra": {
      "decimal": 314.25,
      "h": 20,
      "m": 57,
      "s": 0
    },
    "dec": {
      "decimal": 31.216666666666665,
      "d": 31,
      "m": 13,
      "s": 0
    },
    "desccred": "https://nasa.gov/",
    "description": "Do you see the bat? It haunts this cosmic close-up of the eastern Veil Nebula. The Veil Nebula itself is a large supernova remnant, the expanding debris cloud from the death explosion of a massive star. While the Veil is roughly circular in shape and covers nearly 3 degrees on the sky toward the constellation of the Swan (Cygnus), the Bat Nebula, NGC 6995, spans only 1/2 degree, about the apparent size of the Moon. That translates to 12 light-years at the Veil's estimated distance, a reassuring 1,400 light-years from planet Earth. In the composite of image data recorded through broad and narrow band filters, emission from hydrogen atoms in the remnant is shown in red with strong emission from oxygen and nitrogen atoms shown in hues of blue. Of course, in the western part of the Veil lies another seasonal apparition: the Witch's Broom Nebula."
  },
  {
    "label": "NGC 1763",
    "name": "Bean Nebula",
    "type": "Emission Nebula",
    "constellation": "Dorado",
    "magnitude": 9.4,
    "credit": "Public Domain",
    "img": 9,
    "ra": {
      "decimal": 74.21458333333334,
      "h": 4,
      "m": 56,
      "s": 51.5
    },
    "dec": {
      "decimal": -66.40694444444445,
      "d": -66,
      "m": 24,
      "s": 25
    },
    "description": "NGC 1763 (also known as N11 B, LH 10 or ESO 85-EN20) is an emission nebula with an embedded star cluster in the Dorado constellation in the Large Magellanic Cloud, It is very bright, very large and very irregular. Its apparent size is about 3.0-5.0 arcmin.  It is part of a large region of stars called LMC-N11 (N11) which was discovered with a 23-cm telescope by the astronomer James Dunlop in 1826 and was also observed by John Herschel in 1834. The nebula itself is catalogued under LHA 120-N 11B (N11 B), LH 10 or ESO 85-EN20. It is also part of an area commonly known as the Bean Nebula.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 6888",
    "name": "Crescent Nebula",
    "type": "Emission Nebula",
    "constellation": "Cygnus",
    "magnitude": 7.4,
    "credit": "Public Domain",
    "img": 10,
    "ra": {
      "decimal": 303.02916666666664,
      "h": 20,
      "m": 12,
      "s": 7
    },
    "dec": {
      "decimal": 38.355000000000004,
      "d": 38,
      "m": 21,
      "s": 18
    },
    "description": "The Crescent Nebula (also known as NGC 6888, Caldwell 27, Sharpless 105) is an emission nebula in the constellation Cygnus, about 5000 light-years away from Earth. It was discovered by William Herschel in 1792. It is formed by the fast stellar wind from the Wolf-Rayet star WR 136 (HD 192163) colliding with and energizing the slower moving wind ejected by the star when it became a red giant around 250,000 to 400,000 years ago. The result of the collision is a shell and two shock waves, one moving outward and one moving inward. The inward moving shock wave heats the stellar wind to X-ray-emitting temperatures.\nIt is a rather faint object located about 2 degrees SW of Sadr. For most telescopes it requires a UHC or OIII filter to see. Under favorable circumstances a telescope as small as 8 cm (with filter) can see its nebulosity. Larger telescopes (20 cm or more) reveal the crescent or a Euro sign shape which makes some to call it the \"Euro sign nebula\".",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 6826",
    "name": "Blinking Planetary",
    "type": "Planetary Nebula",
    "constellation": "Cygnus",
    "magnitude": 8.8,
    "credit": "NASA/CXC/RIT/J.Kastner et al.",
    "img": 11,
    "ra": {
      "decimal": 296.2,
      "h": 19,
      "m": 44,
      "s": 48
    },
    "dec": {
      "decimal": 50.525,
      "d": 50,
      "m": 31,
      "s": 30
    },
    "description": "NGC 6826 (also known as Caldwell 15) is a planetary nebula located  in the constellation Cygnus. It is commonly referred to as the \"blinking planetary\", although many other nebulae exhibit such \"blinking\". When viewed through a small telescope, the brightness of the central star overwhelms the eye when viewed directly, obscuring the surrounding nebula. However, it can be viewed well using averted vision, which causes it to \"blink\" in and out of view as the observer's eye wanders.\nA distinctive feature of this nebula are the two bright patches on either side, which are known as Fast Low-Ionization Emission Regions, or FLIERS. They appear to be relatively young, moving outwards at supersonic speeds.The central star of the planetary nebula is an O-type star with a spectral type of O6fp.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 3918",
    "name": "Blue Planetary",
    "type": "Planetary Nebula",
    "constellation": "Centaurus",
    "magnitude": 8.5,
    "credit": "NASA/ESA/Hubble",
    "img": 12,
    "ra": {
      "decimal": 177.57404562706,
      "h": 11,
      "m": 50,
      "s": 17.7709504944
    },
    "dec": {
      "decimal": -57.18250480623,
      "d": -57,
      "m": 10,
      "s": 57.017302428
    },
    "description": "NGC 3918 is a bright planetary nebula in the constellation Centaurus, nicknamed the \"Blue Planetary\" or \"The Southerner\". It is the brightest of the far southern planetary nebulae. This nebula was discovered by Sir John Herschel in March 1834 and is easily visible through small telescopes. The round or even slightly oval diameter is telescopically between 8 and 10 arcsec, though deep images extends this to about 19 or 20 arcsec. More surprising is the beautiful rich blue colour that looks much like the coloured images of Neptune taken by Voyager 2 in 1989.\nSpectroscopy reveals NGC 3918 is approaching us at 17±3.0 kilometres per second, while the nebulosity is expanding at around 24 kilometres per second. The central star is 14.6 visible light magnitude, and remains invisible to optical observers, as it is obscured by the sheer brightness of the surrounding nebula.The distance is estimated at 1.5 kpc (4 900 Light-years).",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "ESO 172-7",
    "name": "Boomerang Nebula",
    "type": "Protoplanetary Nebula",
    "constellation": "Centaurus",
    "magnitude": 10.54,
    "credit": "NASA/ESA/Hubble",
    "img": 13,
    "ra": {
      "decimal": 191.19204793429,
      "h": 12,
      "m": 44,
      "s": 46.0915042296
    },
    "dec": {
      "decimal": -54.52036929466,
      "d": -54,
      "m": 31,
      "s": 13.329460776
    },
    "description": "The Boomerang Nebula is a protoplanetary nebula located 5,000 light-years away from Earth in the constellation Centaurus. It is also known as the Bow Tie Nebula and catalogued as  \nLEDA 3074547. The nebula's temperature is measured at 1 K (−272.15 °C; −457.87 °F) making it the coolest natural place currently known in the Universe.The Boomerang Nebula is believed to be a star system evolving toward the planetary nebula phase. It continues to form and develop due to the outflow of gas from its core where a star in its late stage life sheds mass and emits starlight illuminating dust in the nebula. Millimeter scale dust grains mask portions of the nebula's center so most escaping visible light is in two opposing lobes forming a distinctive hourglass shape as viewed from Earth. The outflowing gas is moving outwards at a speed of about 164 km/s and expanding rapidly as it moves out into space; this gas expansion results in the nebula's unusually low temperature.\nKeith Taylor and Mike Scarrott called it the \"Boomerang Nebula\" in 1980 after observing it with the Anglo-Australian telescope at the Siding Spring Observatory. Unable to view it with great clarity, the astronomers saw merely a slight asymmetry in the nebula's lobes suggesting a curved shape like a boomerang. The nebula was photographed in detail by the Hubble Space Telescope in 1998 revealing a more symmetric hourglass shape.\nIn 1995, using the 15-metre Swedish-ESO Submillimetre Telescope in Chile, astronomers revealed that it is the coldest place in the Universe found so far, besides laboratory-created temperatures. With a temperature of −272 °C, it is only 1 °C warmer than absolute zero (the lowest limit for all temperatures). Even the −270 °C background glow from the Big Bang is warmer than the nebula. It is the only object found so far that has a temperature lower than the background radiation.In 2013, observations of the ALMA radio interferometer revealed other features of the Boomerang Nebula. The visible double lobe of the Boomerang Nebula was observed to be surrounded by a larger spherical volume of cold gas seen only in sub-millimeter radio wavelengths. The nebula's outer fringes appear to be gradually warming.\nAs of mid-2017, it is believed that the star at the center of the nebula is a dying red giant.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 40",
    "name": "Bow-Tie Nebula",
    "type": "Planetary Nebula",
    "constellation": "Cepheus",
    "magnitude": 10.384,
    "credit": "NASA, ESA, K. Noll (STScI)",
    "img": 14,
    "ra": {
      "decimal": 3.254166666666667,
      "h": 0,
      "m": 13,
      "s": 1
    },
    "dec": {
      "decimal": 72.52194444444444,
      "d": 72,
      "m": 31,
      "s": 19
    },
    "description": "NGC 40 (also known as the Bow-Tie Nebula and Caldwell 2) is a planetary nebula discovered by William Herschel on November 25, 1788, and is composed of hot gas around a dying star. The star has ejected its outer layer which has left behind a smaller, hot star with a temperature on the surface of about 50,000 degrees Celsius. Radiation from the star causes the shed outer layer to heat to about 10,000 degrees Celsius, and is about one light-year across. About 30,000 years from now, scientists theorize that NGC 40 will fade away, leaving only a white dwarf star approximately the size of Earth.Currently the central star of NGC 40 has a spectral type of [WC8], indicating a spectrum similar to that of a carbon-rich Wolf–Rayet star.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "OH 231.84 +4.22",
    "name": "Calabash Nebula",
    "type": "Protoplanetary Nebula",
    "constellation": "Puppis",
    "magnitude": 9.47,
    "credit": "ESA/Hubble",
    "img": 15,
    "ra": {
      "decimal": 115.5706125,
      "h": 7,
      "m": 42,
      "s": 16.947
    },
    "dec": {
      "decimal": -14.713944444444444,
      "d": -14,
      "m": 42,
      "s": 50.2
    },
    "description": "The Calabash Nebula, also known as the Rotten Egg Nebula or by its technical name OH 231.84 +4.22, is a protoplanetary nebula (PPN) 1.4 light years (13 Pm) long and located some 5,000 light years (47 Em) from Earth in the constellation Puppis. The name \"Calabash Nebula\" was first proposed in 1989 in an early paper on the expected nebular dynamics, based on the nebula's appearance \nThe Calabash is an almost certain member of the open cluster Messier 46, as it has the same distance, radial velocity, and proper motion. The central star is QX Puppis, a binary composed of a very cool mira variable and an A-type main sequence star.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 1499",
    "name": "California Nebula",
    "type": "Emission Nebula",
    "constellation": "Perseus",
    "magnitude": 6,
    "credit": "NASA/JPL-Caltech/WISE Team",
    "img": 16,
    "ra": {
      "decimal": 60.825,
      "h": 4,
      "m": 3,
      "s": 18
    },
    "dec": {
      "decimal": 36.42166666666667,
      "d": 36,
      "m": 25,
      "s": 18
    },
    "description": "The California Nebula (NGC 1499/Sh2-220) is an emission nebula located in the constellation Perseus. Its name comes from its resemblance to the outline of the US State of California in long exposure photographs. It is almost 2.5° long on the sky and, because of its very low surface brightness, it is extremely difficult to observe visually. It can be observed with a Hα filter (isolates the Hα line at 656 nm) or Hβ filter (isolates the Hβ line at 486 nm) in a rich-field telescope under dark skies. It lies at a distance of about 1,000 light years from Earth. Its fluorescence is due to excitation of the Hβ line in the nebula by the nearby prodigiously energetic O7 star, Xi Persei (also known as Menkib, seen at center below it in the inset at right).The California Nebula was discovered by E. E. Barnard in 1884.\nBy coincidence, the California Nebula transits in the zenith in central California as the latitude matches the declination of the object.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "Cas A",
    "name": "Cassiopeia A",
    "type": "Supernova Remnant",
    "constellation": "Cassiopeia",
    "magnitude": 6,
    "credit": "NASA/JPL-Caltech",
    "img": 17,
    "ra": {
      "decimal": 350.85,
      "h": 23,
      "m": 23,
      "s": 24
    },
    "dec": {
      "decimal": 58.815,
      "d": 58,
      "m": 48,
      "s": 54
    },
    "description": "Cassiopeia A (Cas A) (listen) is a supernova remnant (SNR) in the constellation Cassiopeia and the brightest extrasolar radio source in the sky at frequencies above 1 GHz. The supernova occurred approximately 11,000 light-years (3.4 kpc) away within the Milky Way; given the width of the Orion Arm it is placed in the next-nearest arm outwards, the Perseus Arm, about 30 degrees from the Galactic anticenter. The expanding cloud of material left over from the supernova now appears approximately 10 light-years (3 pc) across from Earth's perspective. In wavelengths of visible light, it has been seen with amateur telescopes down to 234 mm (9.25 in) with filters.It is estimated that light from the stellar explosion (supernova) itself first reached Earth near to the decade of the 1690s, from which time there are no definitively corresponding records. Cas A is circumpolar at and above mid-Northern latitudes which had extensive records and basic telescopes. Its likely omission in records is probably due to interstellar dust absorbing optical wavelength radiation before it reached Earth (although it is possible that it was recorded as a sixth magnitude star 3 Cassiopeiae by John Flamsteed on 16 August 1680). Possible explanations lean toward the idea that the source star was unusually massive and had previously ejected much of its outer layers. These outer layers would have cloaked the star and re-absorbed much of the light released as the inner star collapsed.\nCas A was among the first discrete astronomical radio sources found. Its discovery was reported in 1948 by Martin Ryle and Francis Graham-Smith, astronomers at Cambridge, based on observations with the Long Michelson Interferometer. The optical component was first identified in 1950. Cas A is 3C461 in the Third Cambridge Catalogue of Radio Sources and G111.7-2.1 in the Green Catalog of Supernova Remnants.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 6543",
    "name": "Cat's Eye Nebula",
    "type": "Planetary Nebula",
    "constellation": "Draco",
    "magnitude": 9.8,
    "credit": "NASA/CXC/RIT/J.Kastner et al.",
    "img": 18,
    "ra": {
      "decimal": 269.6375,
      "h": 17,
      "m": 58,
      "s": 33
    },
    "dec": {
      "decimal": 66.63277777777778,
      "d": 66,
      "m": 37,
      "s": 58
    },
    "description": "The Cat's Eye Nebula (also known as NGC 6543 and Caldwell 6) is a planetary nebula in the northern constellation of Draco, discovered by William Herschel on February 15, 1786. It was the first planetary nebula whose spectrum was investigated by the English amateur astronomer William Huggins, demonstrating that planetary nebulae were gaseous and not stellar in nature. Structurally, the object has had high-resolution images by the Hubble Space Telescope revealing knots, jets, bubbles and complex arcs, being illuminated by the central hot planetary nebula nucleus (PNN).\nIt is a well-studied object that has been observed from radio to X-ray wavelengths.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 6334",
    "name": "Cat's Paw Nebula",
    "type": "Emission Nebula",
    "constellation": "Scorpius",
    "magnitude": 10,
    "credit": "Public Domain",
    "img": 19,
    "ra": {
      "decimal": 260.21208333333334,
      "h": 17,
      "m": 20,
      "s": 50.9
    },
    "dec": {
      "decimal": -36.115,
      "d": -36,
      "m": 6,
      "s": 54
    },
    "description": "NGC 6334, colloquially known as the Cat's Paw Nebula, Bear Claw Nebula, or Gum 64, is an emission nebula and star-forming region located in the constellation Scorpius. NGC 6334 was discovered by astronomer John Herschel in 1837, who observed it from the Cape of Good Hope in South Africa. The nebula is located in the Carina–Sagittarius Arm of the Milky Way, at a distance of approximately 5.5 kilolight-years from the Sun.The nebula is a high mass filamentary cloud structure spanning ~320 ly.\nIn the visisble part of the spectrum, it emits meinly in red (from hydrogen atoms) and blue (from oxygen atoms). Several embedded star-forming regions have been identified from infrared and radio emissions. Four of these sites have formed H II regions.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 2264",
    "name": "Cone Nebula",
    "type": "Emission Nebula",
    "constellation": "Monoceros",
    "magnitude": 3.9,
    "credit": "NASA/ESA/Hubble",
    "img": 20,
    "ra": {
      "decimal": 100.3125,
      "h": 6,
      "m": 41,
      "s": 15
    },
    "dec": {
      "decimal": 9.35,
      "d": 9,
      "m": 21,
      "s": 0
    },
    "description": "The Cone Nebula is an H II region in the constellation of Monoceros. It was discovered by William Herschel on December 26, 1785, at which time he designated it H V.27. The nebula is located about 830 parsecs or 2,700 light-years away from Earth. The Cone Nebula forms part of the nebulosity surrounding the Christmas Tree Cluster. The designation of NGC 2264 in the New General Catalogue refers to both objects and not the nebula alone.\nThe diffuse Cone Nebula, so named because of its apparent shape, lies in the southern part of NGC 2264, the northern part being the magnitude-3.9 Christmas Tree Cluster.  It is in the northern part of Monoceros, just north of the midpoint of a line from Procyon to Betelgeuse.\nThe cone's shape comes from a dark absorption nebula consisting of cold molecular hydrogen and dust in front of a faint emission nebula containing hydrogen ionized by S Monocerotis, the brightest star of NGC 2264.  The faint nebula is approximately seven light-years long (with an apparent length of 10 arcminutes), and is 2,700 light-years away from Earth.\nThe nebula is part of a much larger star-forming complex—the Hubble Space Telescope was used to capture images of forming stars in 1997.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "Sh2-103",
    "name": "Cygnus Loop",
    "type": "Supernova Remnant",
    "constellation": "Cygnus",
    "magnitude": 5,
    "credit": "NASA/JPL-Caltech",
    "img": 21,
    "ra": {
      "decimal": 312.75,
      "h": 20,
      "m": 51,
      "s": 0
    },
    "dec": {
      "decimal": 30.666666666666668,
      "d": 30,
      "m": 40,
      "s": 0
    },
    "description": "The Cygnus Loop (radio source W78, or Sharpless 103) is a large supernova remnant (SNR) in the constellation Cygnus, an emission nebula measuring nearly 3° across. Some arcs of the loop, known collectively as the Veil Nebula or Cirrus Nebula, emit in the visible electromagnetic range. Radio, infrared, and X-ray images reveal the complete loop.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "GAL 298.4-00.4",
    "name": "Dragonfish Nebula",
    "type": "Emission Nebula",
    "constellation": "Crux",
    "magnitude": 5,
    "credit": "NASA/JPL-Caltech",
    "img": 22,
    "ra": {
      "decimal": 182.86458333333334,
      "h": 12,
      "m": 11,
      "s": 27.5
    },
    "dec": {
      "decimal": -62.919444444444444,
      "d": -62,
      "m": 55,
      "s": 10
    },
    "description": "The Dragonfish Nebula, as it is known for its appearance on infrared images, is a massive emission nebula and star-forming region 30,000 light-years from the Sun in the direction of the constellation Crux, the Southern Cross.The Dragonfish Nebula gets its name from a giant toothy fish known as the deep-sea dragonfish. The giant stars in this nebula blow a bubble in the surrounding gas. This bubble is over 100 light-years long and forms the mouth of the dragonfish. The two largest and luminous stars, which form its eyes, are said to be newly formed stars. The stars heat up the surrounding gas, giving off infrared light. The Dragonfish Nebula contains some of the most massive stars in the milky way galaxy.This nebula was first discovered in 2010 by Mubdi Rahman and Norman Murray from the University of Toronto. They discovered a cloud of ionized gas which led them to suspect that it was formed from the radiation of nearby stars. Since then more than four hundred stars have been found and there is reason to believe that many smaller stars are hiding in the cluster. The ionized gas around this cluster produces more microwaves than most clusters in our galaxy, making the Dragonfish Nebula the brightest and most massive cluster discovered so far.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "M27",
    "name": "Dumbbell Nebula",
    "type": "Planetary Nebula",
    "constellation": "Vulpecula",
    "magnitude": 7.4,
    "credit": "Public Domain",
    "img": 23,
    "ra": {
      "decimal": 299.9015792,
      "h": 19,
      "m": 59,
      "s": 36
    },
    "dec": {
      "decimal": 22.7210417,
      "d": 22,
      "m": 43,
      "s": 16
    },
    "description": "The Dumbbell Nebula (also known as the Apple Core Nebula, Messier 27, and NGC 6853) is a planetary nebula (nebulosity surrounding a white dwarf) in the constellation Vulpecula, at a distance of about 1360 light-years. It was the first such nebula to be discovered, by Charles Messier in 1764. At its brightness of visual magnitude 7.5 and diameter of about 8 arcminutes, it is easily visible in binoculars and is a popular observing target in amateur telescopes.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "CRL 2688",
    "name": "Egg Nebula",
    "type": "Planetary Nebula",
    "constellation": "Cygnus",
    "magnitude": 14,
    "credit": "NASA/ESA/Hubble",
    "img": 24,
    "ra": {
      "decimal": 315.576125,
      "h": 21,
      "m": 2,
      "s": 18.27
    },
    "dec": {
      "decimal": 36.69361111111111,
      "d": 36,
      "m": 41,
      "s": 37
    },
    "description": "The Egg Nebula (also known as RAFGL 2688 and CRL 2688) is a bipolar protoplanetary nebula approximately 3,000 light-years away from Earth. Its peculiar properties were first described in 1975 using data from the 11 µm survey obtained with sounding rocket by Air Force Geophysical Laboratory (AFGL) in 1971 to 1974. (Previously, the object was catalogued by Fritz Zwicky as a pair of galaxies.)\nThe Egg Nebula's defining feature is the series of bright arcs and circles surrounding the central star. A dense layer of gas and dusts enshrouds the central star, blocking its direct light from our view.  However, the light from the central star penetrates the thinner regions of this dusty enclosure, illuminating the outer layers of gas to create the arcs seen in this resplendent image (Hubble Site).   Spectra of the starlight scattered by the dust reveal that the central star has a spectral type of F5.  The photosphere of an F5 star is about 900 K hotter than that of the Sun, but it is still not hot enough to have begun ionizing the nebula.  Therefore the Egg Nebula is at a slightly earlier evolutionary stage than the Westbrook Nebula whose spectral type B0 central star has just recently begun to ionize the nebula.\nThe dusty enclosure around the central star is very likely a disc.  The bipolar outflows in the image indicate that the system has angular momentum, which is very likely generated by an accretion disc.  In addition, a disc geometry would account for the varying thickness of the enclosure that allows light to escape along the disc's axis and illuminate the outer layers of gas, but still blocks it from our direct view along the disc edge.  Although dusty discs have been confirmed around several post-AGB objects (S. De Ruyter et al., 2006), a disc around the Egg Nebula is yet to be confirmed.\nThe Egg Nebula shows strong microwave emission from rotational transitions of carbon monoxide (CO) and hydrogen cyanide (HCN).  The presence of strong HCN emission indicates that the progenitor AGB star was a carbon star.  The CO and HCN spectra have a strong blue-shifted P Cygni absorption feature, and show the presence of a ~100 km/sec high velocity wind inside of the remnant AGB wind (which is expanding at 18 km/sec).The Egg Nebula was photographed by the Wide Field and Planetary Camera 2 of the NASA/ESA Hubble Space Telescope.\nThe Egg Nebula emits polarized light which can also be detected visually by a medium-sized telescope.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 3132",
    "name": "Eight-Burst Nebula",
    "type": "Planetary Nebula",
    "constellation": "Vela",
    "magnitude": 9.87,
    "credit": "NASA/ESA/Hubble",
    "img": 25,
    "ra": {
      "decimal": 151.75416666666666,
      "h": 10,
      "m": 7,
      "s": 1
    },
    "dec": {
      "decimal": -40.436388888888885,
      "d": -40,
      "m": 26,
      "s": 11
    },
    "description": "NGC 3132 (also known as the Eight-Burst Nebula, the Southern Ring Nebula, or Caldwell 74) is a bright and extensively studied planetary nebula in the constellation Vela.  Its distance from Earth is estimated at about 613 pc. or 2,000 light-years.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "IC 1396A",
    "name": "Elephant's Trunk Nebula",
    "type": "Emission Nebula",
    "constellation": "Cepheus",
    "magnitude": 3.5,
    "credit": "Public Domain",
    "img": 26,
    "ra": {
      "decimal": 324,
      "h": 21,
      "m": 36,
      "s": 0
    },
    "dec": {
      "decimal": 57.4,
      "d": 57,
      "m": 24,
      "s": 0
    },
    "description": "The Elephant's Trunk Nebula is a concentration of interstellar gas and dust within the much larger ionized gas region IC 1396 located in the constellation Cepheus about 2,400 light years away from Earth. The piece of the nebula shown here is the dark, dense globule IC 1396A; it is commonly called the Elephant's Trunk nebula because of its appearance at visible light wavelengths, where there is a dark patch with a bright, sinuous rim. The bright rim is the surface of the dense cloud that is being illuminated and ionized by a very bright, massive star (HD 206267) that is just to the east of IC 1396A. (In the Spitzer Space Telescope view shown, the massive star is just to the left of the edge of the image.) The entire IC 1396 region is ionized by the massive star, except for dense globules that can protect themselves from the star's harsh ultraviolet rays.\nThe Elephant's Trunk Nebula is now thought to be a site of star formation, containing several very young (less than 100,000 yr) stars that were discovered in infrared images in 2003. Two older (but still young, a couple of million years, by the standards of stars, which live for billions of years) stars are present in a small, circular cavity in the head of the globule. Winds from these young stars may have emptied the cavity.\nThe combined action of the light from the massive star ionizing and compressing the rim of the cloud, and the wind from the young stars shifting gas from the center outward lead to very high compression in the Elephant's Trunk Nebula. This pressure has triggered the current generation of protostars.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "MyCn 18",
    "name": "Engraved Hourglass Nebula",
    "type": "Planetary Nebula",
    "constellation": "Musca",
    "magnitude": 13,
    "credit": "NASA/Hubble",
    "img": 27,
    "ra": {
      "decimal": 204.89631666666668,
      "h": 13,
      "m": 39,
      "s": 35.116
    },
    "dec": {
      "decimal": -67.38095833333333,
      "d": -67,
      "m": 22,
      "s": 51.45
    },
    "description": "The Engraved Hourglass Nebula (also known as MyCn 18) is a young planetary nebula in the southern constellation Musca. It was discovered by Annie Jump Cannon and Margaret W. Mayall during their work on an extended Henry Draper Catalogue (the catalogue was built between 1918 and 1924). At the time, it was designated simply as a small faint planetary nebula. Much improved telescopes and imaging techniques allowed the hourglass shape of the nebula to be discovered by Romano Coradi and Hugo Schwarz in images taken during 1991–1992 at the European Southern Observatory. It is conjectured that MyCn 18's hourglass shape is produced by the expansion of a fast stellar wind within a slowly expanding cloud which is denser near its equator than its poles. The vivid colours given off by the nebula are the result of different 'shells' of elements being expelled from the dying star, in this case helium, nitrogen, oxygen and carbon.\nThe Hourglass Nebula was photographed by the Wide Field and Planetary Camera 2 of the Hubble Space Telescope.\nA less-famous \"Hourglass Nebula\" is located inside the Lagoon Nebula.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "M 1-42",
    "name": "Eye Of Sauron Nebula",
    "type": "Planetary Nebula",
    "constellation": "Sagittarius",
    "magnitude": 13.1,
    "credit": "NASA/ESA/Hubble",
    "img": 28,
    "ra": {
      "decimal": 272.77079166666664,
      "h": 18,
      "m": 11,
      "s": 4.99
    },
    "dec": {
      "decimal": -28.983083333333333,
      "d": -28,
      "m": 58,
      "s": 59.1
    },
    "description": "M 1-42 is a planetary nebula located in the constellation of Sagittarius, 10 000 light-years away from Earth.\nThe nebula has been nicknamed the \"Eye of Sauron Nebula\" due to its resemblance to the Lord of the Rings film artifact.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "PN G290.5+07.9",
    "name": "Fleming 1",
    "type": "Planetary Nebula",
    "constellation": "Centaurus",
    "magnitude": 7.6,
    "credit": "ESO",
    "img": 29,
    "ra": {
      "decimal": 172.15083333333334,
      "h": 11,
      "m": 28,
      "s": 36.2
    },
    "dec": {
      "decimal": -52.93458333333333,
      "d": -52,
      "m": 56,
      "s": 4.5
    },
    "description": "Fleming 1 is an unusual planetary nebula situated in the Centaurus constellation. It has a pair of symmetrical jets spanning more than 2.8 pc and delineated with a number of knots. The jets and knots are moving away from the center of the nebula and were probably ejected 10,000 to 16,000 years ago. The innermost part of the nebula has a butterfly shape and is immersed into a faint halo. The butterfly's wings point in the direction of jets with their axis titled by 50° to the line of sight. The waist of the \"butterfly\" is surrounded by a torus of expanding hot gas forming the inner bright ellipse. Fleming 1 is probably 5,000 years old.Like any other planetary nebula Fleming 1 was formed when an old asymptotic giant branch (AGB) star lost its outer hydrogen-rich envelope, leaving behind a hot core (young white dwarf)—the central star of the nebula. The star in the center of Fleming 1 has a temperature of 80,000 ± 15,000 K and mass of 0.56+0.3−0.04 M☉.Observations performed by European Southern Observatory showed that the central star is in fact a double degenerate (made of two white dwarfs) binary with a period of 1.1953 ± 0.0002 days. The companion is probably an older white dwarf of a higher mass—0.64 to 0.7 M☉. Its temperature is about 120,000 K providing the bulk of high energy photons needed to ionize the nebula. The jets likely formed as a result of accretion of the material from the AGB star onto this white dwarf. The accretion led to the formation of a precessing accretion disk, which was expelling material along its rotational axis leading to the formation of jets and knots. The past accretion events also explain the high temperature of the second white dwarf.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 1788",
    "name": "Cosmic Bat Nebula",
    "type": "Reflection Nebula",
    "constellation": "Orion",
    "magnitude": 9,
    "credit": "ESO",
    "img": 30,
    "ra": {
      "decimal": 76.725,
      "h": 5,
      "m": 6,
      "s": 54
    },
    "dec": {
      "decimal": -3.341666666666667,
      "d": -3,
      "m": 20,
      "s": 30
    },
    "description": "NGC 1788 is a reflection nebula in the constellation of Orion.  It is rather sharply defined on its southwest perimeter where it is flanked by the dark nebula known as Lynds 1616. Lynds 1616 is apparently part of NGC 1788.  The brightest involved star is 10th magnitude and lies in the northwest sector.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 2035",
    "name": "Dragon's Head Nebula",
    "type": "Emission Nebula",
    "constellation": "Dorado",
    "magnitude": 12.29,
    "credit": "ESO",
    "img": 31,
    "ra": {
      "decimal": 83.88333333333334,
      "h": 5,
      "m": 35,
      "s": 32
    },
    "dec": {
      "decimal": -67.585,
      "d": -67,
      "m": 35,
      "s": 6
    },
    "description": "NGC 2035 (also known as ESO 56-EN161 and the Dragon's Head Nebula) is an emission nebula and a H II region in the Dorado constellation and part of the Large Magellanic Cloud.  It was discovered by James Dunlop on August 3, 1826.  Its apparent size is 3.0.NGC 2035 is part of a complex of nebulae and stars, including NGC 2029, NGC 2032 and NGC 2040, found north of the main bar of the LMC.  It consists of large bright gas clouds which are separated by dark dust clouds.  NGC 2029, NGC 2032 and NGC 2035 are star-forming regions, while NGC 2040 is a supernova remnant which contains an open cluster.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 6729",
    "name": "Corona Australis Nebula",
    "type": "Reflection Nebula",
    "constellation": "Corona Australis",
    "magnitude": 9.5,
    "credit": "ESO",
    "img": 32,
    "ra": {
      "decimal": 285.44166666666666,
      "h": 19,
      "m": 1,
      "s": 46
    },
    "dec": {
      "decimal": -36.961111111111116,
      "d": -36,
      "m": 57,
      "s": 40
    },
    "description": "NGC 6729 (also known as Caldwell 68) is a reflection/emission nebula of the Corona Australis Molecular Cloud in the constellation Corona Australis. It was discovered by Johann Friedrich Julius Schmidt in 1861.This fan-shaped nebula opens from the star R Coronae Australis toward the star T CrA to the south-east. R CrA is a pre-main-sequence star in the Corona Australis molecular complex, one of the closer star-forming regions of the galaxy at a distance of 130 pc. NGC 6729 is a variable nebula which shows irregular variations in brightness and in shape.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 6514",
    "name": "Trifid Nebula",
    "type": "Emission Nebula",
    "constellation": "Sagittarius",
    "magnitude": 6.3,
    "credit": "ESO",
    "img": 33,
    "ra": {
      "decimal": 274.9917,
      "h": 18,
      "m": 2,
      "s": 23
    },
    "dec": {
      "decimal": -17.1017,
      "d": -23,
      "m": 1,
      "s": 48
    },
    "description": "The Trifid Nebula (catalogued as Messier 20 or M20 and as NGC 6514) is an H II region in the north-west of Sagittarius in a star-forming region in the Milky Way's Scutum-Centaurus Arm. It was discovered by Charles Messier on June 5, 1764. Its name means 'three-lobe'. The object is an unusual combination of an open cluster of stars, an emission nebula (the relatively dense, reddish-pink portion), a reflection nebula (the mainly NNE blue portion), and a dark nebula (the apparent 'gaps' in the former that cause the trifurcated appearance, also designated Barnard 85). Viewed through a small telescope, the Trifid Nebula is a bright and peculiar object, and is thus a perennial favorite of amateur astronomers.The most massive star that has formed in this region is HD 164492A, an O7.5III star with a mass more than 20 times the mass of the Sun.\nThis star is surrounded by a cluster of approximately 3100 young stars.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "Gum 15",
    "name": "Gum Nebula",
    "type": "Emission Nebula",
    "constellation": "Vela-Puppis",
    "magnitude": 12,
    "credit": "ESO",
    "img": 34,
    "ra": {
      "decimal": 130.96875,
      "h": 8,
      "m": 43,
      "s": 52.5
    },
    "dec": {
      "decimal": -41.244166666666665,
      "d": -41,
      "m": 14,
      "s": 39
    },
    "description": "The Gum Nebula (Gum 12) is an emission nebula that extends across 36° in the southern constellations Vela and Puppis. It lies approximately 450 parsecs from the Earth. Hard to distinguish, it was widely believed to be the greatly expanded (and still expanding) remains of a supernova that took place about a million years ago. More recent research suggests it may be an evolved H II region. It contains the 11,000-year-old Vela Supernova Remnant, along with the Vela Pulsar.\nThe Gum Nebula contains about 32 cometary globules. These dense cloud cores are subject to such strong radiation from O-type stars γ2 Vel and ζ Pup and formerly the progenitor of the Vela Supernova Remnant that the cloud cores evaporate away from the hot stars into comet-like shapes. Like ordinary Bok globules, cometary globules are believed to be associated with star formation.It is named after its discoverer, the Australian astronomer Colin Stanley Gum (1924–1960).  Gum had published his findings in 1955 in a work called A study of diffuse southern H-alpha nebulae (see Gum catalog).\nThe Gum nebula was photographed during Apollo 16 while the command module was in the double umbra of the Sun and Earth, using high-speed Kodak film.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 6188",
    "name": "Fighting Dragons Nebula",
    "type": "Emission Nebula",
    "constellation": "Ara",
    "magnitude": 5.2,
    "credit": "Public Domain",
    "img": 35,
    "ra": {
      "decimal": 250,
      "h": 16,
      "m": 40,
      "s": 0
    },
    "dec": {
      "decimal": -48.5,
      "d": -48,
      "m": 30,
      "s": 0
    },
    "description": "NGC 6188 is an emission nebula located about 4,000 light years away in the constellation Ara. The bright open cluster NGC 6193, visible to the naked eye, is responsible for a region of reflection nebulosity within NGC 6188.NGC 6188 is a star forming nebula, and is sculpted by the massive, young stars that have recently formed there – some are only a few million years old.  This spark of formation was probably caused when the last batch of stars went supernova.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "IC 1795",
    "name": "Fishhead Nebula",
    "type": "Emission Nebula",
    "constellation": "Cassiopeia",
    "magnitude": 18.3,
    "credit": "Carsten Frenzl",
    "img": 36,
    "ra": {
      "decimal": 36.43125,
      "h": 2,
      "m": 25,
      "s": 43.5
    },
    "dec": {
      "decimal": 62.103611111111114,
      "d": 62,
      "m": 6,
      "s": 13
    },
    "desccred": "https://nasa.gov/",
    "description": "To some, this nebula looks like the head of a fish. However, this colorful cosmic portrait really features glowing gas and obscuring dust clouds in IC 1795, a star forming region in the northern constellation Cassiopeia. Not far on the sky from the famous Double Star Cluster in Perseus, IC 1795 is itself located next to IC 1805, the Heart Nebula, as part of a complex of star forming regions that lie at the edge of a large molecular cloud. Located just over 6,000 light-years away, the larger star forming complex sprawls along the Perseus spiral arm of our Milky Way Galaxy. At that distance, this picture would span about 70 light-years across IC 1795."
  },
  {
    "label": "NGC 2024",
    "name": "Flame Nebula",
    "type": "Emission Nebula",
    "constellation": "Orion",
    "magnitude": 10,
    "credit": "NASA/JPL-Caltech",
    "img": 37,
    "ra": {
      "decimal": 85.42916666666666,
      "h": 5,
      "m": 41,
      "s": 43
    },
    "dec": {
      "decimal": -1.8416666666666668,
      "d": -1,
      "m": 50,
      "s": 30
    },
    "description": "The Flame Nebula, designated as NGC 2024 and Sh2-277, is an emission nebula in the constellation Orion. It is about 900 to 1,500 light-years away.\nThe bright star Alnitak (ζ Ori), the easternmost star in the Belt of Orion, shines energetic ultraviolet light into the Flame and this knocks electrons away from the great clouds of hydrogen gas that reside there. Much of the glow results when the electrons and ionized hydrogen recombine. Additional dark gas and dust lies in front of the bright part of the nebula and this is what causes the dark network that appears in the center of the glowing gas. The Flame Nebula is part of the Orion molecular cloud complex, a star-forming region that includes the famous Horsehead Nebula.\nAt the center of the Flame Nebula is a cluster of newly formed stars, 86% of which have circumstellar disks. X-ray observations by the Chandra X-ray Observatory show several hundred young stars, out of an estimated population of 800 stars. X-ray and infrared images indicate that the youngest stars are concentrated near the center of the cluster.\n\n",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "IC 405",
    "name": "Flaming Star Nebula",
    "type": "Reflection Nebula",
    "constellation": "Auriga",
    "magnitude": 6,
    "credit": "Public Domain",
    "img": 38,
    "ra": {
      "decimal": 79.25,
      "h": 5,
      "m": 17,
      "s": 0
    },
    "dec": {
      "decimal": 34.38333333333333,
      "d": 34,
      "m": 23,
      "s": 0
    },
    "description": "IC 405 (also known as the Flaming Star Nebula, Sh2-229, or Caldwell 31) is an emission and reflection nebula in the constellation Auriga north of the celestial equator, surrounding the bluish star AE Aurigae. It shines at magnitude +6.0. Its celestial coordinates are RA 05h 16.2m  dec +34° 28′. It surrounds the irregular variable star AE Aurigae and is located near the emission nebula IC 410, the open clusters M38 and M36, and the  K-class star Iota Aurigae.\nThe nebula measures approximately 37.0' x 19.0', and lies about 1,500 light-years away from Earth. It is believed that the proper motion of the central star can be traced back to the Orion's Belt area. The nebula is about 5 light-years across.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 2264",
    "name": "Fox Fur Nebula",
    "type": "Emission Nebula",
    "constellation": "Monoceros",
    "magnitude": 3.9,
    "credit": "Public Domain",
    "img": 39,
    "ra": {
      "decimal": 100.21708333333333,
      "h": 6,
      "m": 40,
      "s": 52.1
    },
    "dec": {
      "decimal": 9.876944444444446,
      "d": 9,
      "m": 52,
      "s": 37
    },
    "description": "The Fox Fur Nebula is a nebula (a formation of gas and dust) located in the constellation of Monoceros (the Unicorn) not far off the right arm of Orion and included in the NGC 2264 Region. In the Sharpless catalog it is number 273.\nThe image is a close-up of a small section of a much larger complex, generally known as the Christmas Tree cluster. The Cone Nebula is also a part of this same cloud.\nThe red regions of this nebula are caused by hydrogen gas that has been stimulated to emit its own light by the copious ultraviolet radiation coming from the hot, blue stars of the cluster.  The blue areas shine by a different process: they are mainly dust clouds that reflect the bluish light of the same stars.\nIts popular name arises because the nebula looks like the head of a stole made from the fur of a red fox.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "IRAS 09371+1212",
    "name": "Frosty Leo Nebula",
    "type": "Protoplanetary Nebula",
    "constellation": "Leo",
    "magnitude": 11,
    "credit": "NASA/ESA/Hubble",
    "img": 40,
    "ra": {
      "decimal": 144.97483333333332,
      "h": 9,
      "m": 39,
      "s": 53.96
    },
    "dec": {
      "decimal": 11.981277777777779,
      "d": 11,
      "m": 58,
      "s": 52.6
    },
    "description": "The Frosty Leo Nebula is a protoplanetary nebula (PPN) located roughly at 3000 light-years away from Earth in the direction of the constellation Leo. It is a spectral bipolar nebula. Its central star is of optical spectral type K7II, by itself called Frosty Leo. It is unusual in that it has an extremely deep absorption feature at 3.1 µm and is unusually located at more than 900 pc above the plane of our galaxy.(Bourke et al. 2000)  Further, as of 1990, it has the only known PPN circumstellar outflow in which crystalline ice dominates the long-wavelength emission spectrum and the only known PPN with point-reflection-symmetric deviations from axial symmetry.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 3324",
    "name": "Gabriela Mistral Nebula",
    "type": "Emission Nebula",
    "constellation": "Carina",
    "magnitude": 6.7,
    "credit": "Public Domain",
    "img": 41,
    "ra": {
      "decimal": 159.34083333333334,
      "h": 10,
      "m": 37,
      "s": 21.8
    },
    "dec": {
      "decimal": -58.615,
      "d": -58,
      "m": 36,
      "s": 54
    },
    "description": "NGC 3324 is an open cluster in the southern constellation Carina, located northwest of the Carina Nebula (NGC 3372) at a distance of 9,100 ly (2,800 pc) from Earth. It is closely associated with the emission nebula IC 2599, also known as Gum 31. The two are often confused as a single object, and together have been nicknamed the \"Gabriela Mistral Nebula\" due to its resemblance to the Chilean poet. NGC 3324 was first catalogued by James Dunlop in 1826.NGC 3324 is associated with the open cluster NGC 3293. Both are fairly young, at around 12 million years old. They show some degree of mass segregation, with more massive stars concentrated near their centers. Neither are dynamically relaxed.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 2080",
    "name": "Ghost Head Nebula",
    "type": "Emission Nebula",
    "constellation": "Dorado",
    "magnitude": 10.42,
    "credit": "NASA/ESA/Hubble",
    "img": 42,
    "ra": {
      "decimal": 84.9275,
      "h": 5,
      "m": 39,
      "s": 42.6
    },
    "dec": {
      "decimal": -69.64722222222223,
      "d": -69,
      "m": 38,
      "s": 50
    },
    "description": "NGC 2080 (The Ghost Head Nebula) is a star-forming region and emission nebula to the south of the 30 Doradus (Tarantula) nebula, in the southern constellation Dorado. It belongs to the Large Magellanic Cloud, a satellite galaxy to the Milky Way, which is at a distance of 168,000 light years. NGC 2080 was discovered by John Frederick William Herschel in 1834. The Ghost Head Nebula has a diameter of 50 light-years and is named for the two distinct white patches it possesses, called the \"eyes of the ghost\". The western patch, called A1, has a bubble in the center which was created by the young, massive star it contains. The eastern patch, called A2, has several young stars in a newly formed cluster, but they are still obscured by their originating dust cloud. Because neither dust cloud has dissipated due to the stellar radiation, astronomers have deduced that both sets of stars formed within the past 10,000 years. These stars together have begun to create a bubble in the nebula with their outpourings of material, called stellar wind.The presence of stars also greatly influences the color of the nebula. The western portion of the nebula has a dominant oxygen emission line because of a powerful star on the nebula's outskirts; this colors it green. The rest of the nebula's outskirts have a red hue due to the ionization of hydrogen. Because both hydrogen and oxygen are ionized in the central region, which appears pale yellow; when hydrogen is energized enough to emit a second wavelength of light, it appears blue, as in the area surrounding A1 and A2.NGC 2080 should not be confused with the Ghost Nebula (Sh2-136) or the Little Ghost Nebula (NGC 6369).",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "IC 2118",
    "name": "Witch Head Nebula",
    "type": "Reflection Nebula",
    "constellation": "Orion",
    "magnitude": 13,
    "credit": "NASA/STScI Digitized Sky Survey/Noel Carboni",
    "img": 43,
    "ra": {
      "decimal": 75.5,
      "h": 5,
      "m": 2,
      "s": 0
    },
    "dec": {
      "decimal": -7.9,
      "d": -7,
      "m": 54,
      "s": 0
    },
    "description": "IC 2118 (also known as Witch Head Nebula due to its shape) is an extremely faint reflection nebula believed to be an ancient supernova remnant or gas cloud illuminated by nearby supergiant star Rigel in the constellation of Orion. It lies in the Orion constellation, about 900 light-years from Earth. The nature of the dust particles, reflecting blue light better than red, is a factor in giving the Witch Head its blue color. Radio observations show substantial carbon monoxide emission throughout parts of IC 2118, an indicator of the presence of molecular clouds and star formation in the nebula. In fact candidates for pre-main sequence stars and some classic T-Tauri stars have been found deep within the nebula.The molecular clouds of IC 2118 are probably juxtaposed to the outer boundaries of the vast Orion-Eridanus bubble, a giant supershell of molecular hydrogen blown by the high mass stars of the Orion OB1 association. As the supershell expands into the interstellar medium, favorable circumstances for star formation occur. IC 2118 is located in one such area. The wind blown appearance and cometary shape of the bright reflection nebula is highly suggestive of a strong association with the high mass luminous stars of Orion OB1. The fact that the heads of the cometary clouds of IC2118 point northeast towards the association is strong support of that relationship.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 3242",
    "name": "Ghost Of Jupiter Nebula",
    "type": "Planetary Nebula",
    "constellation": "Hydra",
    "magnitude": 8.6,
    "credit": "NASA/JPL-Caltech/Harvard-Smithsonian CfA",
    "img": 44,
    "ra": {
      "decimal": 156.19166666666666,
      "h": 10,
      "m": 24,
      "s": 46
    },
    "dec": {
      "decimal": -18.642222222222223,
      "d": -18,
      "m": 38,
      "s": 32
    },
    "description": "NGC 3242 (also known as the Ghost of Jupiter or Caldwell 59) is a planetary nebula located  in the constellation Hydra.\nWilliam Herschel discovered the nebula on February 7, 1785, and cataloged it as H IV.27. John Herschel observed it from the Cape of Good Hope, South Africa, in the 1830s, and numbered it as h 3248, and included it in the 1864 General Catalogue as GC 2102; this became NGC 3242 in J. L. E. Dreyer's New General Catalogue of 1888.\nThis planetary nebula is most frequently called the Ghost of Jupiter, or Jupiter's Ghost due to its similar size to the planet, but it is also sometimes referred to as the Eye Nebula. The nebula measures around two light years long from end to end, and contains a central white dwarf with an apparent magnitude of eleven. The inner layers of the nebula were formed some 1,500 years ago.  The two ends of the nebula are marked by FLIERs, lobes of fast moving gas often tinted red in false-color pictures. NGC 3242 can easily be observed with amateur telescopes and appears bluish-green to most observers. Larger telescopes can distinguish the outer halo as well.At the center of NGC 3242 is an O-type star with a spectral type of O(H).",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 6751",
    "name": "Dandelion Puffball Nebula",
    "type": "Planetary Nebula",
    "constellation": "Aquila",
    "magnitude": 11.9,
    "credit": "NASA/ESA/Hubble",
    "img": 45,
    "ra": {
      "decimal": 286.48140990643,
      "h": 19,
      "m": 5,
      "s": 55.5383775432
    },
    "dec": {
      "decimal": -5.9923024615400005,
      "d": -5,
      "m": 59,
      "s": 32.288861544
    },
    "description": "NGC 6751, also known as the Glowing Eye Nebula or the Dandelion Puffball Nebula, is a planetary nebula in the constellation Aquila. It is estimated to be about 6,500 light-years (2.0 kiloparsecs) away.NGC 6751 was discovered by the astronomer Albert Marth on 20 July 1863. John Louis Emil Dreyer, the compiler of the New General Catalogue, described the object as \"pretty bright, small\". The object was assigned a duplicate designation, NGC 6748.The nebula was the subject of the winning picture in the 2009 Gemini School Astronomy Contest, in which Australian high school students competed to select an astronomical target to be imaged by Gemini.NGC 6751 is an easy telescopic target for deep-sky observers because its location is immediately southeast of the extremely red-colored cool carbon star V Aquilae.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "W33",
    "name": "Godzilla Nebula",
    "type": "Supernova Remnant",
    "constellation": "Sagittarius",
    "magnitude": 10,
    "credit": "NASA/JPL-Caltech",
    "img": 46,
    "ra": {
      "decimal": 273.55833333333334,
      "h": 18,
      "m": 14,
      "s": 14
    },
    "dec": {
      "decimal": -17.930555555555557,
      "d": -17,
      "m": 55,
      "s": 50
    },
    "desccred": "https://nasa.gov/",
    "description": `This colorful image shows a nebula – a cloud of gas and dust in space – captured by NASA's now-retired Spitzer Space Telescope located is in the constellation Sagittarius, along the plane of the Milky Way, which was as part of Spitzer's GLIMPSE Survey (short for Galactic Legacy Infrared Mid-Plane Survey Extraordinaire). With a little imagination, you might be able to see the outlines of Godzilla. Figure 1 features a line drawing that highlights how parts of this nebula resemble the movie monster.

Stars in the upper right (where this cosmic Godzilla's eyes and snout would be) are an unknown distance from Earth but within our galaxy. Located about 7,800 light-years from Earth, the bright region in the lower left (Godzilla's right hand) is known as W33.

When viewed in visible light, this region is almost entirely obscured by dust clouds. But infrared light (wavelengths longer than what our eyes can perceive) can penetrate the clouds, revealing hidden regions like this one.`,
  },
  {
    "label": "NGC 3372",
    "name": "Defiant Finger",
    "type": "Dark Nebula",
    "constellation": "Carina",
    "magnitude": 1,
    "credit": "NASA/ESA/Hubble",
    "img": 47,
    "ra": {
      "decimal": 161.125,
      "h": 10,
      "m": 44,
      "s": 30
    },
    "dec": {
      "decimal": -59.666666666666664,
      "d": -59,
      "m": 40,
      "s": 0
    },
    "description": "A small Bok globule in the Keyhole Nebula (at RA 10h 44m 30s, Dec −59° 40') has been photographed by the Hubble Space Telescope and is nicknamed the \"Carina Defiant Finger\" due to its shape. In Hubble images, light can be seen radiating off the edges of the globule; this is especially visible in the southern tip, where the \"finger\" is. It is thought that the Defiant Finger is being ionized by the bright Wolf–Rayet star WR 25, and/or Trumpler 16-244, a bright blue supergiant. It has a mass of at least 6 M☉, and stars may be forming within it. Like other interstellar clouds under intense radiation, the Defiant Finger will eventually be completely evaporated; for this cloud the time frame is predicted to be 200,000 to 1,000,000 years.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 7293",
    "name": "Helix Nebula",
    "type": "Planetary Nebula",
    "constellation": "Aquarius",
    "magnitude": 7.28,
    "credit": "NASA/JPL-Caltech",
    "img": 48,
    "ra": {
      "decimal": 337.40833333333336,
      "h": 22,
      "m": 29,
      "s": 38
    },
    "dec": {
      "decimal": -20.836944444444445,
      "d": -20,
      "m": 50,
      "s": 13
    },
    "description": "The Helix Nebula (also known as NGC 7293 or Caldwell 63) is a planetary nebula (PN) located in the constellation Aquarius. Discovered by Karl Ludwig Harding, probably before 1824, this object is one of the closest to the Earth of all the bright planetary nebulae. The distance, measured by the Gaia mission, is 655±13 light-years. It is similar in appearance to the Cat's Eye Nebula and the Ring Nebula, whose size, age, and physical characteristics are similar to the Dumbbell Nebula, varying only in its relative proximity and the appearance from the equatorial viewing angle.  The Helix Nebula has sometimes been referred to as the \"Eye of God\" in pop culture, as well as the \"Eye of Sauron\".",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 3372",
    "name": "Homunculus Nebula",
    "type": "Reflection Nebula",
    "constellation": "Carina",
    "magnitude": 6.19,
    "credit": "NASA/ESA/Hubble",
    "img": 49,
    "ra": {
      "decimal": 161.26458333333332,
      "h": 10,
      "m": 45,
      "s": 3.5
    },
    "dec": {
      "decimal": -59.68444444444444,
      "d": -59,
      "m": 41,
      "s": 4
    },
    "description": "The Homunculus Nebula is a bipolar emission and reflection nebula surrounding the massive star system Eta Carinae, about 7,500 light-years (2,300 parsecs) from Earth.  The nebula is embedded within the much larger Carina Nebula, a large star-forming H II region. From the Latin homunculus meaning Little Man, the nebula consists of gas which was ejected from Eta Carinae during the Great Eruption, which occurred ~7,500 years before it was observed on Earth, from 1838 to 1845. It also contains dust which absorbs much of the light from the extremely luminous central stellar system and re-radiates it as infra-red (IR).  It is the brightest object in the sky at mid-IR wavelengths.Within the Homunculus is a smaller Little Homunculus, and within that a shell of shocked material from stellar winds that has been called Baby Homunculus.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "Barnard 33",
    "name": "Horsehead Nebula",
    "type": "Dark Nebula",
    "constellation": "Orion",
    "magnitude": 6.8,
    "credit": "Public Domain",
    "img": 50,
    "ra": {
      "decimal": 85.24583333333334,
      "h": 5,
      "m": 40,
      "s": 59
    },
    "dec": {
      "decimal": -2.4583333333333335,
      "d": -2,
      "m": 27,
      "s": 30
    },
    "description": "The Horsehead Nebula (also known as Barnard 33) is a small dark nebula in the constellation Orion. The nebula is located just to the south of Alnitak, the easternmost star of Orion's Belt, and is part of the much larger Orion molecular cloud complex. It appears within the southern region of the dense dust cloud known as Lynds 1630, along the edge of the much larger, active star-forming H II region called IC 434.The Horsehead Nebula is approximately 422 parsecs or 1,375 light-years from Earth. It is one of the most identifiable nebulae because of its resemblance to a horse's head.\n\n",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 2261",
    "name": "Hubble's Variable Nebula",
    "type": "Reflection Nebula",
    "constellation": "Monoceros",
    "magnitude": 9,
    "credit": "NASA/ESA/Hubble",
    "img": 51,
    "ra": {
      "decimal": 99.7875,
      "h": 6,
      "m": 39,
      "s": 9
    },
    "dec": {
      "decimal": 8.735833333333332,
      "d": 8,
      "m": 44,
      "s": 9
    },
    "description": "NGC 2261 (also known as Hubble's Variable Nebula or Caldwell 46) is a variable nebula located in the constellation Monoceros. The nebula is illuminated by the star R Monocerotis (R Mon), which is not directly visible itself.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 5194",
    "name": "Whirlpool Galaxy",
    "type": "Spiral Galaxy",
    "constellation": "Canes Venatici",
    "magnitude": 8.4,
    "credit": "NASA/ESA",
    "img": 52,
    "ra": {
      "decimal": 202.469575,
      "h": 13,
      "m": 29,
      "s": 52
    },
    "dec": {
      "decimal": 47.1952583,
      "d": 47,
      "m": 11,
      "s": 43
    },
    "description": "The Whirlpool Galaxy, also known as Messier 51a, M51a, and NGC 5194, is an interacting grand-design spiral galaxy with a Seyfert 2 active galactic nucleus. It lies in the constellation Canes Venatici, and was the first galaxy to be classified as a spiral galaxy. Its distance is 31 million light-years away from Earth.The galaxy and its companion, NGC 5195, are easily observed by amateur astronomers, and the two galaxies may be seen with binoculars. The Whirlpool Galaxy has been extensively observed by professional astronomers, who study it to understand galaxy structure (particularly structure associated with the spiral arms) and galaxy interactions.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 1976",
    "name": "Orion Nebula",
    "type": "Emission Nebula",
    "constellation": "Orion",
    "magnitude": 4,
    "credit": "NASA/ESA/Hubble",
    "img": 53,
    "ra": {
      "decimal": 83.8220792,
      "h": 5,
      "m": 35,
      "s": 17
    },
    "dec": {
      "decimal": -5.3911111,
      "d": -5,
      "m": 23,
      "s": 28
    },
    "description": "The Orion Nebula (also known as Messier 42, M42, or NGC 1976) is a diffuse nebula situated in the Milky Way, being south of Orion's Belt in the constellation of Orion. It is one of the brightest nebulae and is visible to the naked eye in the night sky with apparent magnitude 4.0. It is 1,344 ± 20 light-years (412.1 ± 6.1 pc) away and is the closest region of massive star formation to Earth. The M42 nebula is estimated to be 24 light-years across (so its apparent size from Earth is approximately 1 degree). It has a mass of about 2,000 times that of the Sun. Older texts frequently refer to the Orion Nebula as the Great Nebula in Orion or the Great Orion Nebula.The Orion Nebula is one of the most scrutinized and photographed objects in the night sky and is among the most intensely studied celestial features. The nebula has revealed much about the process of how stars and planetary systems are formed from collapsing clouds of gas and dust. Astronomers have directly observed protoplanetary disks and brown dwarfs within the nebula, intense and turbulent motions of the gas, and the photo-ionizing effects of massive nearby stars in the nebula.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 1275",
    "name": "Perseus A",
    "type": "Elliptical Galaxy",
    "constellation": "Perseus",
    "magnitude": 11.6,
    "credit": "NASA/ESA/Hubble",
    "img": 54,
    "ra": {
      "decimal": 49.95,
      "h": 3,
      "m": 19,
      "s": 48
    },
    "dec": {
      "decimal": 41.51166666666666,
      "d": 41,
      "m": 30,
      "s": 42
    },
    "description": "NGC 1275 (also known as Perseus A or Caldwell 24) is a type 1.5 Seyfert galaxy located around 237 million light-years away in the direction of the constellation Perseus. NGC 1275 corresponds to the radio galaxy Perseus A and is situated near the center of the large Perseus Cluster of galaxies.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 6302",
    "name": "Butterfly Nebula",
    "type": "Planetary Nebula",
    "constellation": "Scorpius",
    "magnitude": 13,
    "credit": "NASA/ESA/Hubble",
    "img": 55,
    "ra": {
      "decimal": 258.43333333333334,
      "h": 17,
      "m": 13,
      "s": 44
    },
    "dec": {
      "decimal": -37.10277777777778,
      "d": -37,
      "m": 6,
      "s": 10
    },
    "description": "NGC 6302 (also known as the Bug Nebula, Butterfly Nebula, or Caldwell 69) is a bipolar planetary nebula in the constellation Scorpius. The structure in the nebula is among the most complex ever observed in planetary nebulae. The spectrum of NGC 6302 shows that its central star is one of the hottest stars known, with a surface temperature in excess of 250,000 degrees Celsius, implying that the star from which it formed must have been very large.\nThe central star, a white dwarf, was identified in 2009, using the upgraded Wide Field Camera 3 on board the Hubble Space Telescope. The star has a current mass of around 0.64 solar masses. It is surrounded by a dense equatorial disc composed of gas and dust. This dense disc is postulated to have caused the star's outflows to form a bipolar structure similar to an hourglass. This bipolar structure shows features such as ionization walls, knots and sharp edges to the lobes.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "ESO 127-18",
    "name": "Westerlund 2",
    "type": "Star Cluster",
    "constellation": "Carina",
    "magnitude": 10.5,
    "credit": "NASA/ESA/Hubble",
    "img": 56,
    "ra": {
      "decimal": 155.99208333333334,
      "h": 10,
      "m": 23,
      "s": 58.1
    },
    "dec": {
      "decimal": -57.76361111111111,
      "d": -57,
      "m": 45,
      "s": 49
    },
    "description": "Westerlund 2  is an obscured compact young star cluster (perhaps even a super star cluster) in the Milky Way, with an estimated age of about one or two million years. It contains some of the hottest, brightest, and most massive stars known. The cluster resides inside a stellar breeding ground known as Gum 29, located 20,000 light-years away in the constellation Carina.  It is half a degree from the naked eye Cepheid variable V399 Carinae.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 2014",
    "name": "Cosmic Reef",
    "type": "Emission Nebula",
    "constellation": "Dorado",
    "magnitude": 7.5,
    "credit": "ESA/Hubble",
    "img": 57,
    "ra": {
      "decimal": 83.09879166666667,
      "h": 5,
      "m": 32,
      "s": 23.71
    },
    "dec": {
      "decimal": -67.70156111111112,
      "d": -67,
      "m": 42,
      "s": 5.62
    },
    "description": "NGC 2014 is a red emission nebula surrounding an open cluster of stars in the Large Magellanic Cloud, at a distance of about 163,000 light-years.The nebula was discovered on 3 August 1826 by James Dunlop. Together with NGC 2020 it makes up what is called the Cosmic Reef.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 6960",
    "name": "Witch's Broom Nebula",
    "type": "Supernova Remnant",
    "constellation": "Cygnus",
    "magnitude": 7,
    "credit": "ESA/Hubble & NASA, Z. Levay",
    "img": 58,
    "ra": {
      "decimal": 311.40833333333336,
      "h": 20,
      "m": 45,
      "s": 38
    },
    "dec": {
      "decimal": 30.708333333333332,
      "d": 30,
      "m": 42,
      "s": 30
    },
    "desccred": "https://nasa.gov/",
    "description": "Ten thousand years ago, before the dawn of recorded human history, a new light would have suddenly have appeared in the night sky and faded after a few weeks. Today we know this light was from a supernova, or exploding star, and record the expanding debris cloud as the Veil Nebula, a supernova remnant. This sharp telescopic view is centered on a western segment of the Veil Nebula cataloged as NGC 6960 but less formally known as the Witch's Broom Nebula. Blasted out in the cataclysmic explosion, the interstellar shock wave plows through space sweeping up and exciting interstellar material. Imaged with narrow band filters, the glowing filaments are like long ripples in a sheet seen almost edge on, remarkably well separated into atomic hydrogen (red) and oxygen (blue-green) gas. The complete supernova remnant lies about 1400 light-years away towards the constellation Cygnus. This Witch's Broom actually spans about 35 light-years. The bright star in the frame is 52 Cygni, visible with the unaided eye from a dark location but unrelated to the ancient supernova remnant."
  },
  {
    "label": "Messier 101",
    "name": "Pinwheel Galaxy",
    "type": "Spiral Galaxy",
    "constellation": "Ursa Major",
    "magnitude": 7.9,
    "credit": "NASA/ESA/Hubble",
    "img": 59,
    "ra": {
      "decimal": 210.80242916666666,
      "h": 14,
      "m": 3,
      "s": 12.583
    },
    "dec": {
      "decimal": 54.34875,
      "d": +54,
      "m": 20,
      "s": 55.50
    },
    "description": "The Pinwheel Galaxy (also known as Messier 101, M101 or NGC 5457) is a face-on spiral galaxy 21 million light-years (6.4 megaparsecs) away from Earth in the constellation Ursa Major. It was discovered by Pierre Méchain in 1781 and was communicated that year to Charles Messier, who verified its position for inclusion in the Messier Catalogue as one of its final entries.\nOn February 28, 2006, NASA and the European Space Agency released a very detailed image of the Pinwheel Galaxy, which was the largest and most-detailed image of a galaxy by Hubble Space Telescope at the time. The image was composed of 51 individual exposures, plus some extra ground-based photos.\nOn August 24, 2011, a Type Ia supernova, SN 2011fe, was discovered in M101.\n\n",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 6611",
    "name": "Eagle Nebula",
    "type": "Emission Nebula",
    "constellation": "Serpens",
    "magnitude": 6.2,
    "credit": "NASA/ESA/Hubble",
    "img": 60,
    "ra": {
      "decimal": 274.7,
      "h": 18,
      "m": 18,
      "s": 48
    },
    "dec": {
      "decimal": -13.8067,
      "d": -13,
      "m": 49,
      "s": 0
    },
    "description": "The Eagle Nebula (catalogued as Messier 16 or M16, and as NGC 6611, and also known as the Star Queen Nebula and The Spire) is a young open cluster of stars in the constellation Serpens, discovered by Jean-Philippe de Cheseaux in 1745–46. Both the \"Eagle\" and the \"Star Queen\" refer to visual impressions of the dark silhouette near the center of the nebula, an area made famous as the \"Pillars of Creation\" imaged by the Hubble Space Telescope. The nebula contains several active star-forming gas and dust regions, including the aforementioned Pillars of Creation. The Eagle Nebula lies in the Sagittarius Arm of the Milky Way.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 1952",
    "name": "Crab Nebula",
    "type": "Supernova Remnant",
    "constellation": "Taurus",
    "magnitude": 8.4,
    "credit": "NASA/ESA/Hubble",
    "img": 61,
    "ra": {
      "decimal": 83.6330833,
      "h": 5,
      "m": 34,
      "s": 31.94
    },
    "dec": {
      "decimal": 22.0145,
      "d": 22,
      "m": 0,
      "s": 52
    },
    "description": "The Crab Nebula (catalogue designations M1, NGC 1952, Taurus A) is a supernova remnant and pulsar wind nebula in the constellation of Taurus. The common name comes from William Parsons, 3rd Earl of Rosse, who observed the object in 1842 using a 36-inch (91 cm) telescope and produced a drawing that looked somewhat like a crab. The nebula was discovered by English astronomer John Bevis in 1731, and it corresponds with a bright supernova recorded by Chinese astronomers in 1054. The nebula was the first astronomical object identified that corresponds with a historical supernova explosion.At an apparent magnitude of 8.4, comparable to that of Saturn's moon Titan, it is not visible to the naked eye but can be made out using binoculars under favourable conditions. The nebula lies in the Perseus Arm of the Milky Way galaxy, at a distance of about 2.0 kiloparsecs (6,500 ly) from Earth. It has a diameter of 3.4 parsecs (11 ly), corresponding to an apparent diameter of some 7 arcminutes, and is expanding at a rate of about 1,500 kilometres per second (930 mi/s), or 0.5% of the speed of light.\nAt the center of the nebula lies the Crab Pulsar, a neutron star 28–30 kilometres (17–19 mi) across with a spin rate of 30.2 times per second, which emits pulses of radiation from gamma rays to radio waves. At X-ray and gamma ray energies above 30 keV, the Crab Nebula is generally the brightest persistent gamma-ray source in the sky, with measured flux extending to above 10 TeV. The nebula's radiation allows detailed study of celestial bodies that occult it. In the 1950s and 1960s, the Sun's corona was mapped from observations of the Crab Nebula's radio waves passing through it, and in 2003, the thickness of the atmosphere of Saturn's moon Titan was measured as it blocked out X-rays from the nebula.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 7635",
    "name": "Bubble Nebula",
    "type": "Emission Nebula",
    "constellation": "Cassiopeia",
    "magnitude": 10,
    "credit": "NASA/ESA/Hubble",
    "img": 63,
    "ra": {
      "decimal": 350.2,
      "h": 23,
      "m": 20,
      "s": 48
    },
    "dec": {
      "decimal": 61.20166666666667,
      "d": 61,
      "m": 12,
      "s": 6
    },
    "description": "NGC 7635, also known as the Bubble Nebula, Sharpless 162, or Caldwell 11, is an H II region emission nebula in the constellation Cassiopeia. It lies close to the direction of the open cluster Messier 52. The \"bubble\" is created by the stellar wind from a massive hot, 8.7 magnitude young central star, SAO 20575 (BD+60°2522). The nebula is near a giant molecular cloud which contains the expansion of the bubble nebula while itself being excited by the hot central star, causing it to glow. It was discovered in 1787 by William Herschel. The star BD+60°2522 is thought to have a mass of about 44 M☉.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 2070",
    "name": "Tarantula Nebula",
    "type": "Emission Nebula",
    "constellation": "Dorado",
    "magnitude": 7.25,
    "credit": "NASA/ESA/Hubble",
    "img": 64,
    "ra": {
      "decimal": 84.675,
      "h": 5,
      "m": 38,
      "s": 42
    },
    "dec": {
      "decimal": -69.1,
      "d": -69,
      "m": 6,
      "s": 0
    },
    "description": "The Tarantula Nebula (also known as 30 Doradus) is a large H II region in the Large Magellanic Cloud (LMC), forming its south-east corner (from Earth's perspective).",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 292",
    "name": "Small Magellanic Cloud",
    "type": "Irregular Galaxy",
    "constellation": "Tucana",
    "magnitude": 2.7,
    "credit": "NASA/ESA/Hubble",
    "img": 65,
    "ra": {
      "decimal": 13.158333333333333,
      "h": 0,
      "m": 52,
      "s": 38
    },
    "dec": {
      "decimal": -72.80027777777778,
      "d": -72,
      "m": 48,
      "s": 1
    },
    "description": "The Small Magellanic Cloud (SMC), or Nubecula Minor, is a dwarf galaxy near the Milky Way. Classified as a dwarf irregular galaxy, the SMC has a diameter of about 7,000 light-years, contains several hundred million stars, and has a total mass of approximately 7 billion solar masses. The SMC contains a central bar structure, and astronomers speculate that it was once a barred spiral galaxy that was disrupted by the Milky Way to become somewhat irregular. At a distance of about 200,000 light-years, the SMC is among the nearest intergalactic neighbors of the Milky Way and is one of the most distant objects visible to the naked eye.\nThe SMC is visible from the entire Southern Hemisphere, but can be fully glimpsed low above the southern horizon from latitudes south of about 15° north. The galaxy is located across both the constellations of Tucana and part of Hydrus, appearing as a faint hazy patch resembling a detached piece of the Milky Way. The SMC has an average apparent diameter of about 4.2° (8 times the Moon's) and thus covers an area of about 14 square degrees (70 times the Moon's). Since its surface brightness is very low, this deep-sky object is best seen on clear moonless nights and away from city lights. The SMC forms a pair with the Large Magellanic Cloud (LMC), which lies 20° to the east, and like the LMC, it is a member of the Local Group. It is currently a satellite of the Milky Way, but is likely a former satellite of the LMC.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 4594",
    "name": "Sombrero Galaxy",
    "type": "Spiral Galaxy",
    "constellation": "Virgo",
    "magnitude": 9,
    "credit": "NASA/ESA/Hubble",
    "img": 66,
    "ra": {
      "decimal": 189.9976333,
      "h": 12,
      "m": 39,
      "s": 59
    },
    "dec": {
      "decimal": -11.6230556,
      "d": -11,
      "m": 37,
      "s": 23
    },
    "description": "The Sombrero Galaxy (also known as Messier Object 104, M104 or NGC 4594) is a perculiar elliptical galaxy in the constellation borders of Virgo and Corvus, being about 9.55 megaparsecs (31.1 million light-years) from our galaxy, within the local supercluster. It has a diameter of approximately 15 kiloparsecs (49,000 light-years), three-tenths the size of the Milky Way. It has a bright nucleus, an unusually large central bulge, and a prominent dust lane in its outer disk, which is viewed almost edge-on. The dark dust lane and the bulge give it the appearance of a sombrero hat. Astronomers initially thought the halo was small and light, indicative of a spiral galaxy; but the Spitzer Space Telescope found that the dust ring was larger and more massive than previously thought, indicative of a giant elliptical galaxy. The galaxy has an apparent magnitude of +8.0, making it easily visible with amateur telescopes, and is considered by some authors to be the galaxy with the highest absolute magnitude within a radius of 10 megaparsecs of the Milky Way. Its large bulge, central supermassive black hole, and dust lane all attract the attention of professional astronomers.\n\n",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 1316",
    "name": "Fornax A",
    "type": "Lenticular Galaxy",
    "constellation": "Fornax",
    "magnitude": 9.4,
    "credit": "NASA/ESA/Hubble",
    "img": 67,
    "ra": {
      "decimal": 50.67412083333333,
      "h": 3,
      "m": 22,
      "s": 41.789
    },
    "dec": {
      "decimal": -37.208200000000005,
      "d": -37,
      "m": 12,
      "s": 29.52
    },
    "description": "NGC 1316 (also known as Fornax A) is a lenticular galaxy about 60 million light-years away in the constellation Fornax. It is a radio galaxy and at 1400 MHz is the fourth-brightest radio source in the sky.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 4038, NGC 4039",
    "name": "Antennae Galaxies",
    "type": "Interacting Galaxy",
    "constellation": "Corvus",
    "magnitude": 11.2,
    "credit": "ESA/Hubble",
    "img": 68,
    "ra": {
      "decimal": 180.47083333333333,
      "h": 12,
      "m": 1,
      "s": 53
    },
    "dec": {
      "decimal": -18.8675,
      "d": -18,
      "m": 52,
      "s": 3
    },
    "description": "The Antennae Galaxies (also known as NGC 4038/NGC 4039 or Caldwell 60/Caldwell 61) are a pair of interacting galaxies in the constellation Corvus. They are currently going through a starburst phase, in which the collision of clouds of gas and dust, with entangled magnetic fields, causes rapid star formation. They were discovered by William Herschel in 1785.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 7027",
    "name": "Jewel Bug Nebula",
    "type": "Planetary Nebula",
    "constellation": "Cygnus",
    "magnitude": 10,
    "credit": "ESA/Hubble",
    "img": 69,
    "ra": {
      "decimal": 316.7565498,
      "h": 21,
      "m": 7,
      "s": 1.571952
    },
    "dec": {
      "decimal": 42.236242000000004,
      "d": 42,
      "m": 14,
      "s": 10.4712
    },
    "description": "NGC 7027, Also known as the Jewel Bug Nebula, is a very young and dense planetary nebula located around 3,000 light-years (920 parsecs) from Earth in the constellation Cygnus. Discovered in 1878 by Édouard Stephan using the 800 mm (31 in) reflector at Marseille Observatory, it is one of the smallest planetary nebulae and by far the most extensively studied.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "IC 63",
    "name": "Ghost of Cassiopeia Nebula",
    "type": "Emission Nebula",
    "constellation": "Cassiopeia",
    "magnitude": 13.33,
    "credit": "NASA/ESA/STScI",
    "img": 70,
    "ra": {
      "decimal": 14.755708333333333,
      "h": 0,
      "m": 59,
      "s": 1.37
    },
    "dec": {
      "decimal": 60.88827777777778,
      "d": 60,
      "m": 53,
      "s": 17.8
    },
    "desccred": "https://nasa.gov/",
    "description": "The brightest stars embedded in nebulae throughout our galaxy pour out a torrent of radiation that eats into vast clouds of hydrogen gas – the raw material for building new stars. This etching process sculpts a fantasy landscape where human imagination can see all kinds of shapes and figures. This nebula in the constellation of Cassiopeia has flowing veils of gas and dust that have earned it the nickname \"Ghost Nebula.\"\n\nOfficially known as IC 63, this nebula is located 550 light-years away in the constellation Cassiopeia the Queen."
  },
  {
    "label": "Simeis 147",
    "name": "Spaghetti Nebula",
    "type": "Supernova Remnant",
    "constellation": "Taurus",
    "magnitude": 6.5,
    "credit": "Public Domain",
    "img": 71,
    "ra": {
      "decimal": 85.275,
      "h": 5,
      "m": 41,
      "s": 6
    },
    "dec": {
      "decimal": 28.083333333333332,
      "d": 28,
      "m": 5,
      "s": 0
    },
    "description": "Simeis 147, also known as the Spaghetti Nebula, SNR G180.0-01.7 or Sharpless 2-240, is a supernova remnant (SNR) in the Milky Way, straddling the border between the constellations Auriga and Taurus. Discovered in 1952 at the Crimean Astrophysical Observatory by Grigory Shajn and his team using a Schmidt camera and a narrowband filter that was close to the Hydrogen Alpha transmission line. It is difficult to observe due to its extremely low brightness. This discovery was part of a survey conducted between 1945 and 1955 most likely using captured German equipment, as the observatory was practically destroyed during WWII. The Schmidt camera had a field of view of 175'. Many previously unknown hydrogen nebula were discovered this way, which did not appear in regular photographs. \nThe nebulous area is fairly large with an almost spherical shell and filamentary structure. The remnant has an apparent diameter of approximately 3 degrees, an estimated distance of approximately 3000 (±350) light-years, and an age of approximately 40,000 years.It is believed that after its stellar explosion a rapidly spinning neutron star known as pulsar PSR J0538+2817 was left behind in the nebula core, emitting a strong radio signal.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 7023",
    "name": "Iris Nebula",
    "type": "Reflection Nebula",
    "constellation": "Cepheus",
    "magnitude": 6.8,
    "credit": "Public Domain",
    "img": 72,
    "ra": {
      "decimal": 315.4,
      "h": 21,
      "m": 1,
      "s": 36
    },
    "dec": {
      "decimal": 68.16333333333334,
      "d": 68,
      "m": 9,
      "s": 48
    },
    "description": "The Iris Nebula (also known as NGC 7023 and Caldwell 4) is a bright reflection nebula in the constellation Cepheus. The designation NGC 7023 refers to the open cluster within the larger reflection nebula designated LBN 487.\nThe nebula, which shines at magnitude +6.8, is illuminated by a magnitude +7.4 star designated SAO 19158. It is located near the Mira-type variable star T Cephei, and near the bright magnitude +3.23 variable star Beta Cephei (Alfirk). It lies 1,300 light-years away and is six light-years across.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "Sh2-135",
    "name": "Jack-o-Lantern Nebula",
    "type": "Emission Nebula",
    "constellation": "Cepheus",
    "magnitude": 10.8,
    "credit": "NASA/JPL-Caltech",
    "img": 73,
    "ra": {
      "decimal": 335.5520833333333,
      "h": 22,
      "m": 22,
      "s": 12.5
    },
    "dec": {
      "decimal": 58.684749999999994,
      "d": 58,
      "m": 41,
      "s": 5.1
    },
    "desccred": "https://nasa.gov/",
    "description": "This carved-out cloud of gas and dust has been nicknamed the \"Jack-o'-lantern Nebula\" because it looks like a cosmic hollowed-out pumpkin. Powerful outflows of radiation and particles from a massive star — known as an O-type star and about 15 to 20 times heavier than the Sun — has likely swept the surrounding dust and gas outward, creating deep gouges in the cloud. The image shows infrared light (which is invisible to the human eye) captured by NASA's Spitzer Space Telescope."
  },
  {
    "label": "IC 443",
    "name": "Jellyfish Nebula",
    "type": "Supernova Remnant",
    "constellation": "Gemini",
    "magnitude": 12,
    "credit": "Public Domain",
    "img": 74,
    "ra": {
      "decimal": 94.51125,
      "h": 6,
      "m": 18,
      "s": 2.7
    },
    "dec": {
      "decimal": 22.66,
      "d": 22,
      "m": 39,
      "s": 36
    },
    "description": "IC 443 (also known as the Jellyfish Nebula and Sharpless 248 (Sh2-248)) is a galactic supernova remnant (SNR) in the constellation Gemini. On the plane of the sky, it is located near the star Eta Geminorum.\nIts distance is roughly 5,000 light years from Earth.\nIC 443 may be the remains of a supernova that occurred 3,000 - 30,000 years ago. The same supernova event likely created the neutron star CXOU J061705.3+222127, the collapsed remnant of the stellar core. IC 443 is one of the best-studied cases of supernova remnants interacting with surrounding molecular clouds.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "IRAS 23166+1655",
    "name": "LL Pegasi",
    "type": "Protoplanetary Nebula",
    "constellation": "Pegasus",
    "magnitude": 10.379,
    "credit": "ALMA (ESO/NAOJ/NRAO)/H. Kim et al.",
    "img": 1,
    "ra": {
      "decimal": 349.802531,
      "h": 23,
      "m": 19,
      "s": 12.60744
    },
    "dec": {
      "decimal": 17.192537,
      "d": 17,
      "m": 11,
      "s": 33.1332
    },
    "description": "LL Pegasi (AFGL 3068) is a Mira variable star surrounded by a pinwheel-shaped nebula, IRAS 23166+1655, thought to be a preplanetary nebula.  It is a binary system that includes an extreme carbon star.  The pair is hidden by the dust cloud ejected from the carbon star and is only visible in infrared light.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "Messier 63",
    "name": "Sunflower Galaxy",
    "type": "Spiral Galaxy",
    "constellation": "Canes Venatici",
    "magnitude": 9.3,
    "credit": "NASA/ESA/Hubble",
    "img": 75,
    "ra": {
      "decimal": 198.9555375,
      "h": 13,
      "m": 15,
      "s": 49
    },
    "dec": {
      "decimal": 42.0292889,
      "d": 42,
      "m": 1,
      "s": 45
    },
    "description": "Messier 63 or M63, also known as NGC 5055 or the seldom-used Sunflower Galaxy, is a spiral galaxy in the northern constellation of Canes Venatici with approximately 400 billion stars. M63 was first discovered by the French astronomer Pierre Méchain, then later verified by his colleague Charles Messier on June 14, 1779. The galaxy became listed as object 63 in the Messier Catalogue. In the mid-19th century, Anglo-Irish astronomer Lord Rosse identified spiral structures within the galaxy, making this one of the first galaxies in which such structure was identified.The shape or morphology of this galaxy has a classification of SAbc, indicating a spiral form with no central bar feature (SA) and moderate to loosely wound arms (bc). There is a general lack of large-scale continuous spiral structure in visible light, so it is considered a flocculent galaxy. However, when observed in the near infrared, a symmetric, two-arm structure is seen. Each arm wraps 150° around the galaxy and extends out to 13,000 light-years (4,000 parsecs) from the nucleus.M63 is a weakly active galaxy with a LINER nucleus – short for 'low-ionization nuclear emission-line region'. This displays as an unresolved source at the galactic nucleus that is cloaked in a diffuse emission. The latter is extended along a position angle of 110° relative to the north celestial pole, and both soft X-rays and hydrogen (H-alpha) emission can be observed coming from along nearly the same direction. The existence of a supermassive black hole (SMBH) at the nucleus is uncertain; if it does exist, then the mass is estimated as (8.5±1.9)×108 M☉, or around 850 million times the mass of the Sun.\nRadio observations at the 21-cm hydrogen line show the gaseous disk of M63 extends outward to a radius of 130,000 light-years (40 kiloparsecs), well past the bright optical disk. This gas shows a symmetrical form that is warped in a pronounced manner, starting at a radius of 33,000 light-years (10 kiloparsecs). The form suggests a dark matter halo that is offset with respect to the inner region. The reason for the warp is unclear, but the position angle points toward the smaller companion galaxy, UGC 8313.The distance to M63, based upon the luminosity-distance measurement is 29,300,000 light-years (8.99 megaparsecs). The radial velocity relative to the Local Group yields an estimate of 15,200,000 light-years (4.65 megaparsecs). Estimates based on the Tully–Fisher relation range over 16,000,000–34,000,000 light-years (5.0–10.3 megaparsecs). The tip of the red-giant branch technique gives a distance of 28,930,000 ± 950,000 light-years (8.87 ± 0.29 megaparsecs). M63 is part of the M51 Group, a group of galaxies that also includes M51 (the 'Whirlpool Galaxy').In 1971, a supernova with a magnitude of 11.8 appeared in one of the arms. It was discovered on May 24 and reached peak light around May 26. The spectrum of this, SN 1971 I, is consistent with a supernova of type I. However, the spectroscopic behavior appeared anomalous.\n\n",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "SN 1604",
    "name": "Kepler's Supernova",
    "type": "Supernova Remnants",
    "constellation": "Ophiuchus",
    "magnitude": 2.5,
    "credit": "NASA/CXC/SAO/D.Patnaude/DSS",
    "img": 76,
    "ra": {
      "decimal": 262.6499,
      "h": 17,
      "m": 30,
      "s": 35.976
    },
    "dec": {
      "decimal": -21.482286111111108,
      "d": -21,
      "m": 28,
      "s": 56.23
    },
    "description": "SN 1604, also known as Kepler's Supernova, Kepler's Nova or Kepler's Star, was a Type Ia supernova that occurred in the Milky Way, in the constellation Ophiuchus. Appearing in 1604, it is the most recent supernova in our galaxy to have been unquestionably observed by the naked eye, occurring no farther than 6 kiloparsecs (20,000 light-years) from Earth. Before the adoption of the current naming system for supernovae, it was named for Johannes Kepler, the German astronomer who described it in De Stella Nova.\n\n",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 3372",
    "name": "Keyhole Nebula",
    "type": "Dark Nebula",
    "constellation": "Carina",
    "magnitude": 6.19,
    "credit": "Public Domain",
    "img": 77,
    "ra": {
      "decimal": 161.25929166666666,
      "h": 10,
      "m": 45,
      "s": 2.23
    },
    "dec": {
      "decimal": -59.69994444444444,
      "d": -59,
      "m": 41,
      "s": 59.8
    },
    "description": "The Keyhole, or Keyhole Nebula, is a small dark cloud of cold molecules and dust within the Carina Nebula, containing bright filaments of hot, fluorescing gas, silhouetted against the much brighter background nebula. John Herschel used the term \"lemniscate-oval vacuity\" when first describing it, and subsequently referred to it simply as the \"oval vacuity\". The term lemniscate continued to be used to describe this portion of the nebula until popular astronomy writer Emma Converse described the shape of the nebula as \"resembling a keyhole\" in an 1873 Appleton's Journal article. The name Keyhole Nebula then came into common use, sometimes for the Keyhole itself, sometimes to describe the whole of the Carina Nebula (signifying \"the nebula that contains the Keyhole\").The diameter of the Keyhole structure is approximately seven light-years (2.1 pc). Its appearance has changed significantly since it was first observed, possibly due to changes in the ionizing radiation from Eta Carinae. The Keyhole does not have its own NGC designation. It is sometimes erroneously called NGC 3324, but that catalogue designation refers to a reflection and emission nebula just northwest of the Carina Nebula (or to its embedded star cluster).",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "IC 3568",
    "name": "Lemon Slice Nebula",
    "type": "Planetary Nebula",
    "constellation": "Camelopardalis",
    "magnitude": 12.3,
    "credit": "NASA/ESA/Hubble",
    "img": 78,
    "ra": {
      "decimal": 188.27856215089,
      "h": 12,
      "m": 33,
      "s": 6.8549162136
    },
    "dec": {
      "decimal": 82.56394517878,
      "d": 82,
      "m": 33,
      "s": 50.202643608
    },
    "description": "IC 3568 is a planetary nebula that is 1.3 kiloparsecs (4500 ly) away from Earth in the constellation of Camelopardalis (just 7.5 degrees from Polaris). It is a relatively young nebula and has a core diameter of only about 0.4 light years.  It was dubbed the Lemon Slice Nebula by Jim Kaler, due to its appearance in one false-colour image from the Hubble Space Telescope. The Lemon slice nebula is one of the most simple nebulae known, with an almost perfectly spherical morphology. The core of the nebula does not have a distinctly visible structure in formation and is mostly composed of ionized helium. A faint halo of interstellar dust surrounds the nebula. The central star of the planetary nebula is an O-type star with a spectral type of O(H)3.IC 3568 was discovered on August 31, 1900 by the American astronomer Robert Grant Aitken while using Lick Observatory's 12\" Clark Refractor. While examining Comet Borrelly-Brooks, he found that the star BD +83° 357 in Camelopardalis is surrounded by a small circular nebula. This was confirmed with the observatory's 36\" Refractor the next night. IC 3568 was misclassified as a compact galaxy in the Uppsala General Catalogue, as UGC 7731.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 2392",
    "name": "Eskimo Nebula",
    "type": "Planetary Nebula",
    "constellation": "Gemini",
    "magnitude": 10,
    "credit": "NASA/ESA/Hubble",
    "img": 79,
    "ra": {
      "decimal": 112.29166666666667,
      "h": 7,
      "m": 29,
      "s": 10
    },
    "dec": {
      "decimal": 20.911666666666665,
      "d": 20,
      "m": 54,
      "s": 42
    },
    "description": "The Eskimo Nebula (NGC 2392), also known as the Clown-faced Nebula, Lion Nebula, or Caldwell 39, is a bipolar double-shell planetary nebula (PN). It was discovered by astronomer William Herschel in 1787. The formation resembles a person's head surrounded by a parka hood. It is surrounded by gas that composed the outer layers of a Sun-like star. The visible inner filaments are ejected by a strong wind of particles from the central star. The outer disk contains unusual, light-year-long filaments.  \nNGC 2392 lies about 6500 light-years away, and is visible with a small telescope in the constellation of Gemini.\nAt the center of NGC 2392, there is an O-type star with a spectral type of O(H)6f.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 6618",
    "name": "Swan Nebula",
    "type": "Emission Nebula",
    "constellation": "Sagittarius",
    "magnitude": 6,
    "credit": "NASA/JPL-Caltech",
    "img": 80,
    "ra": {
      "decimal": 275.1958,
      "h": 18,
      "m": 20,
      "s": 26
    },
    "dec": {
      "decimal": -16.1717,
      "d": -16,
      "m": 10,
      "s": 36
    },
    "description": "The Omega Nebula, also known as the Swan Nebula, Checkmark Nebula, Lobster Nebula, and the Horseshoe Nebula (catalogued as Messier 17 or M17 or NGC 6618) is an H II region in the constellation Sagittarius. It was discovered by Philippe Loys de Chéseaux in 1745. Charles Messier catalogued it in 1764. It is by some of the richest starfields of the Milky Way, figuring in the northern two-thirds of Sagittarius.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 3372",
    "name": "Carina Nebula",
    "type": "Emission Nebula",
    "constellation": "Carina",
    "magnitude": 3,
    "credit": "NASA/ESA/Hubble",
    "img": 81,
    "ra": {
      "decimal": 161.07916666666668,
      "h": 10,
      "m": 44,
      "s": 19
    },
    "dec": {
      "decimal": -59.88916666666667,
      "d": -59,
      "m": 53,
      "s": 21
    },
    "description": "The Carina Nebula or Eta Carinae Nebula (catalogued as NGC 3372; also known as the Great Carina Nebula) is a large, complex area of bright and dark nebulosity in the constellation Carina, and it is located in the Carina–Sagittarius Arm. The nebula is approximately 8,500 light-years (2,600 pc) from Earth.\nThe nebula has within its boundaries the large Carina OB1 association and several related open clusters, including numerous O-type stars and several Wolf–Rayet stars. Carina OB1 encompasses the star clusters Trumpler 14 and Trumpler 16. Trumpler 14 is one of the youngest known star clusters at half a million years old. Trumpler 16 is the home of WR 25, currently the most luminous star known in our Milky Way galaxy, together with the less luminous but more massive and famous Eta Carinae star system and the O2 supergiant HD 93129A. Trumpler 15, Collinder 228, Collinder 232, NGC 3324, and NGC 3293 are also considered members of the association. NGC 3293 is the oldest and furthest from Trumpler 14, indicating sequential and ongoing star formation.\nThe nebula is one of the largest diffuse nebulae in our skies. Although it is four times as large as and even brighter than the famous Orion Nebula, the Carina Nebula is much less well known due to its location in the southern sky. It was discovered by Nicolas-Louis de Lacaille in 1752 from the Cape of Good Hope.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 2264",
    "name": "Christmas Tree Cluster",
    "type": "Open Cluster",
    "constellation": "Monoceros",
    "magnitude": 4.1,
    "credit": "NASA/JPL-Caltech",
    "img": 82,
    "ra": {
      "decimal": 100.21708333333333,
      "h": 6,
      "m": 40,
      "s": 52.1
    },
    "dec": {
      "decimal": 9.876944444444446,
      "d": 9,
      "m": 52,
      "s": 37
    },
    "description": "NGC 2264 is the designation number of the New General Catalogue that identifies two astronomical objects as a single object: the Cone Nebula, and the Christmas Tree Cluster. Two other objects are within this designation but not officially included, the Snowflake Cluster, and the Fox Fur Nebula.All of the objects are located in the Monoceros constellation and are located about 720 parsecs or 2,300 light-years from Earth. Due to its relative proximity and large size, it is extremely well studied.NGC 2264 is sometimes referred to as the Christmas Tree Cluster and the Cone Nebula. However, the designation of NGC 2264 in the New General Catalogue refers to both objects and not the cluster alone.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 2359",
    "name": "Thor's Helmet",
    "type": "Emission Nebula",
    "constellation": "Canis Major",
    "magnitude": 11.45,
    "credit": "Adam Block/Mount Lemmon SkyCenter/University of Arizona",
    "img": 83,
    "ra": {
      "decimal": 109.625,
      "h": 7,
      "m": 18,
      "s": 30
    },
    "dec": {
      "decimal": -13.226666666666667,
      "d": -13,
      "m": 13,
      "s": 36
    },
    "description": "NGC 2359 (also known as Thor's Helmet) is an emission nebula in the constellation Canis Major. The nebula is approximately 3,670 parsecs (11.96 thousand light years) away and 30 light-years in size.  The central star is the Wolf-Rayet star WR7, an extremely hot star thought to be in a brief pre-supernova stage of evolution. It is similar in nature to the Bubble Nebula, but interactions with a nearby large molecular cloud are thought to have contributed to the more complex shape and curved bow-shock structure of Thor's Helmet.\nIt is also catalogued as Sharpless 2-298 and Gum 4.The nebula has an overall bubble shape, but with complex filamentary structures.  The nebula contains several hundred solar masses of ionised material, plus several thousand more of unionised gas.  It is largely interstellar material swept up by winds from the central star, although some material does appear to be enriched with the products of fusion and is likely to come directly from the star.  The expansion rate of different portions of the nebula varies from 10 km/s to at least 30 km/s, leading to age estimates of 78,500 - 236,000 years.  The nebula has been studied at radio and x-ray wavelengths, but it is still unclear whether it was produced at the class O main sequence stage of development, as a red supergiant, luminous blue variable, or mainly as a Wolf-Rayet star.NGC 2361 is a bright knot of nebulosity on one edge of the central ring of NGC 2359.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 1501",
    "name": "Oyster Nebula",
    "type": "Planetary Nebula",
    "constellation": "Camelopardalis",
    "magnitude": 13,
    "credit": "NASA/ESA/Hubble",
    "img": 84,
    "ra": {
      "decimal": 61.74746653691,
      "h": 4,
      "m": 6,
      "s": 59.3919688584
    },
    "dec": {
      "decimal": 60.92063262336583,
      "d": 60,
      "m": 55,
      "s": 14.277444117
    },
    "description": "NGC 1501 is a complex planetary nebula located in the constellation of Camelopardalis, discovered in 27 Aug 1787 by William Herschel. It is also known as the Oyster Nebula. The central star of the planetary nebula has a spectral type of [WC4], similar to that of a carbon-rich Wolf–Rayet star. Its is a pulsating star, meaning that its brightness varies regularly and periodically. In the case of NGC 1501's progenitor star, this is incredibly fast, with the star's brightness changing significantly in just half an hour. An analysis of Gaia data suggests that the central star is a binary system. Visible-light observations capture the glow of gases including hydrogen and nitrogen.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 281",
    "name": "Pacman Nebula",
    "type": "Emission Nebula",
    "constellation": "Cassiopeia",
    "magnitude": 7.4,
    "credit": "NASA/CXC/CfA/S.Wolk",
    "img": 85,
    "ra": {
      "decimal": 13.104583333333334,
      "h": 0,
      "m": 52,
      "s": 25.1
    },
    "dec": {
      "decimal": 56.565,
      "d": 56,
      "m": 33,
      "s": 54
    },
    "description": "NGC 281, IC 11 or Sh2-184 is a bright emission nebula and part of an H II region in the northern constellation of Cassiopeia and is part of the Milky Way's Perseus Spiral Arm. This 20×30 arcmin sized nebulosity is also associated with open cluster IC 1590, several Bok globules and the multiple star, B 1. It collectively forms Sh2-184, spanning over a larger area of 40 arcmin. A recent distance from radio parallaxes of water masers at 22 GHz made during 2014 is estimated it lies 2.82±0.20 kpc. (9200 ly.) from us. Colloquially, NGC 281 is also known as the Pacman Nebula for its resemblance to the video game character.\nEdward Emerson Barnard discovered the nebula in August 1883, describing it as \"a large faint nebula, very diffuse.\"  Multiple star 'B 1' or β 1 was later discovered by S. W. Burnham, whose bright component is identified as the highly luminous O6 spectral class star, HD 5005 or HIP 4121. It consists of an 8th-magnitude primary with four companions at distances between 1.4 and 15.7 arcsec.  There has been no appreciable change in this quintuple system since the first measures were made in 1875.\nThe nebula region is visible in amateur telescopes from dark sky locations.\nIn his book Deep Sky Wonders, Walter Scott Houston describes the appearance of the nebula in small telescopes:\n\"There was a faint glow in the immediate vicinity of the multiple star, with an occasional impression of a much larger nebulosity...Its surface brightness was much less than that of M33 in Triangulum or NGC 205, the distant companion of the Andromeda galaxy.\"",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "Messier 45",
    "name": "The Seven Sisters Cluster",
    "type": "Open Cluster",
    "constellation": "Taurus",
    "magnitude": 1.6,
    "credit": "NASA, ESA, AURA/Caltech",
    "img": 86,
    "ra": {
      "decimal": 56.85,
      "h": 3,
      "m": 47,
      "s": 24
    },
    "dec": {
      "decimal": 24.116666666666667,
      "d": 24,
      "m": 7,
      "s": 0
    },
    "description": "The Pleiades, also known as The Seven Sisters, Messier 45, and other names by different cultures, is an asterism and an open star cluster containing middle-aged, hot B-type stars in the north-west of the constellation Taurus. At a distance of about 444 light years, it is among the nearest star clusters to Earth. It is the nearest Messier object to Earth, and is the most obvious cluster to the naked eye in the night sky.\nThe cluster is dominated by hot blue and luminous stars that have formed within the last 100 million years. Reflection nebulae around the brightest stars were once thought to be left over material from their formation, but are now considered likely to be an unrelated dust cloud in the interstellar medium through which the stars are currently passing. This dust cloud is estimated to be moving at a speed of approximately 18 km/s relative to the stars in the cluster.Computer simulations have shown that the Pleiades were probably formed from a compact configuration that resembled the Orion Nebula. Astronomers estimate that the cluster will survive for about another 250 million years, after which it will disperse due to gravitational interactions with its galactic neighborhood. Together with the open star cluster of the Hyades, the Pleiades form the Golden Gate of the Ecliptic.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "IC 4406",
    "name": "Retina Nebula",
    "type": "Planetary Nebula",
    "constellation": "Lupus",
    "magnitude": 10.9,
    "credit": "NASA/ESA/Hubble",
    "img": 87,
    "ra": {
      "decimal": 215.60893374037,
      "h": 14,
      "m": 22,
      "s": 26.1440976888
    },
    "dec": {
      "decimal": -44.15060697583,
      "d": -44,
      "m": 9,
      "s": 2.185112988
    },
    "description": "IC 4406, sometimes known as the Retina Nebula, is a planetary nebula near the western border of the constellation Lupus, the Wolf. It has dust clouds and has the shape of a torus. Despite this, it looks somewhat rectangular because it is seen from its side as viewed from Earth, almost in the plane of its equator.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 7009",
    "name": "Saturn Nebula",
    "type": "Planetary Nebula",
    "constellation": "Aquarius",
    "magnitude": 8,
    "credit": "NASA/CXC/RIT/J.Kastner et al.",
    "img": 88,
    "ra": {
      "decimal": 316.0416666666667,
      "h": 21,
      "m": 4,
      "s": 10
    },
    "dec": {
      "decimal": -11.363333333333333,
      "d": -11,
      "m": 21,
      "s": 48
    },
    "description": "The Saturn Nebula (also known as NGC 7009 or Caldwell 55) is a planetary nebula in the constellation Aquarius. It appears as a greenish-yellowish hue in a small amateur telescope. It was discovered by William Herschel on September 7, 1782, using a telescope of his own design in the garden at his home in Datchet, England, and was one of his earliest discoveries in his sky survey. The nebula was originally a low-mass star that ejected its layers into space, forming the nebula. The central star is now a bright white dwarf star of apparent magnitude 11.5. The Saturn Nebula gets its name from its superficial resemblance to the planet Saturn with its rings nearly edge-on to the observer. It was so named by Lord Rosse in the 1840s, when telescopes had improved to the point that its Saturn-like shape could be discerned.  William Henry Smyth said that the Saturn Nebula was one of Struve's nine \"Rare Celestial Objects\".The Saturn Nebula is a complex planetary nebula and contains many morphological and kinematic sub-systems in three dimensions.  It includes a halo, jet-like streams, multiple shells, ansae (\"handles\"), and small-scale filaments and knots.  The ansae are expanding non-radially from the central star. Although the ansae are most prominent in the Saturn Nebula, they are also visible in other planetary nebulae, including NGC 3242, NGC 6543 and NGC 2371-2.\nThe distance of the Saturn Nebula is not known precisely. Sabbadin et al. 2004 estimates the distance to be 5,200 light-years (1.6 kpc).  In 1963 O'Dell estimated it to be 3,900 light-years (1.2 kpc), which gives an approximate diameter of 0.5 light years for the object as a whole.\nThe central star, a very hot bluish dwarf with a temperature of 55,000 K, from which the nebula is believed to originate, has an absolute magnitude of +1.5, which equates to a luminosity of about 20 solar luminosities and a visual magnitude of 11.5. This strong ultraviolet irradiation from the central star creates the characteristic fluorescent green tint of the nebula via the radiation of doubly ionized oxygen. The object overall has a visual magnitude of 8 and a radial velocity of 28 miles per second towards the Earth.\nThe nebula is 1 degree west of the star Nu Aquarii. The central portion measures 25″ × 17″, while the outer shell extends to 41″ × 35″.  The object is on many \"best of\" observing lists.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "Sh2-136",
    "name": "Ghost Nebula",
    "type": "Reflection Nebula",
    "constellation": "Cepheus",
    "magnitude": 5,
    "credit": "Adam Block/Mount Lemmon SkyCenter/University of Arizona",
    "img": 89,
    "ra": {
      "decimal": 319.10833333333335,
      "h": 21,
      "m": 16,
      "s": 26
    },
    "dec": {
      "decimal": 68.26,
      "d": 68,
      "m": 15,
      "s": 36
    },
    "description": "The Ghost Nebula (designated Sh2-136, VdB 141) is a reflection nebula located in the constellation Cepheus.\nIt lies near the cluster NGC 7023. Looking at the adjacent image, the nebula's name is easily understood. The Ghost Nebula is referred to as a globule (cataloged CB230) and over 2 light-years across. There are several stars embedded, whose emissions make the nebula shine in brownish colour.\nThe Ghost Nebula should not be confused with the Little Ghost Nebula (NGC 6369), the Ghost Head Nebula (NGC 2080) or the Ghost of Cassiopeia (IC 63).",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 7662",
    "name": "Blue Snowball Nebula",
    "type": "Planetary Nebula",
    "constellation": "Andromeda",
    "magnitude": 8.6,
    "credit": "NASA/CXC/RIT/J.Kastner et al.",
    "img": 90,
    "ra": {
      "decimal": 351.47083333333336,
      "h": 23,
      "m": 25,
      "s": 53
    },
    "dec": {
      "decimal": 42.535,
      "d": 42,
      "m": 32,
      "s": 6
    },
    "description": "NGC 7662 (also known as the Blue Snowball Nebula, Snowball Nebula, and Caldwell 22) is a planetary nebula located  in the constellation Andromeda.\nNGC 7662 is a popular planetary nebula for casual observers. A small telescope will reveal a star-like object with slight nebulosity. A 6\" telescope with a magnification around 100x will reveal a slightly bluish disk, while telescopes with a primary mirror at least 16\" in diameter may reveal slight color and brightness variations in the interior.\nThe central star of the planetary nebula is an O-type star with a spectral type of O(H).\n\n",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "Westerhout 5",
    "name": "Soul Nebula",
    "type": "Emission Nebula",
    "constellation": "Cassiopeia",
    "magnitude": 6.5,
    "credit": "NASA/JPL-Caltech",
    "img": 91,
    "ra": {
      "decimal": 42.855,
      "h": 2,
      "m": 51,
      "s": 25.2
    },
    "dec": {
      "decimal": 60.41888888888889,
      "d": 60,
      "m": 25,
      "s": 8
    },
    "description": "Westerhout 5 (Sharpless 2-199, LBN 667, Soul Nebula) is an emission nebula located in Cassiopeia. Several small open clusters are embedded in the nebula: CR 34, 632, and 634 (in the head) and IC 1848 (in the body). The object is more commonly called by the cluster designation IC 1848.\nSmall emission nebula IC 1871 is present just left of the top of the head, and small emission nebulae 670 and 669 are just below the lower back area.\nThe galaxies Maffei 1 and Maffei 2 are both nearby the nebula, although light extinction from the Milky Way makes them very hard to see.\nOnce thought to be part of the Local Group, they are now known to belong to their own group- the IC 342/Maffei Group.\nThis complex is the eastern neighbor of IC1805 (Heart Nebula) and the two are often mentioned together as the \"Heart and Soul\".",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 2736",
    "name": "Pencil Nebula",
    "type": "Supernova Remnant",
    "constellation": "Vela",
    "magnitude": 12,
    "credit": "ESO",
    "img": 92,
    "ra": {
      "decimal": 135.05,
      "h": 9,
      "m": 0,
      "s": 12
    },
    "dec": {
      "decimal": -45.95,
      "d": -45,
      "m": 57,
      "s": 0
    },
    "description": "NGC 2736 (also known as the Pencil Nebula) is a small part of the Vela Supernova Remnant, located near the Vela Pulsar in the constellation Vela.  The nebula's linear appearance triggered its popular name. It resides about 815 light-years (250 parsecs) away from the Solar System.  It is thought to be formed from part of the shock wave of the larger Vela Supernova Remnant.  The Pencil Nebula is moving at roughly 644,000 kilometers per hour (400,000 miles per hour).",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "Kronberger 61",
    "name": "Soccer Ball Nebula",
    "type": "Planetary Nebula",
    "constellation": "Gemini",
    "magnitude": 8.4,
    "credit": "International Gemini Observatory/AURA",
    "img": 93,
    "ra": {
      "decimal": 290.41223169791,
      "h": 19,
      "m": 21,
      "s": 38.9356074984
    },
    "dec": {
      "decimal": 38.31589368326,
      "d": 38,
      "m": 18,
      "s": 57.217259736
    },
    "description": "Kronberger 61, also known as the \"soccer ball\", is a planetary nebula discovered by an amateur astronomer in January, 2011, with the newer images having been taken by the Gemini Observatory. The nebula is named for Austrian Mattias Kronberger, who is a member of the amateur group Deep Sky Hunters. The object is estimated to lie 13,000 light-years away. They discovered the nebula while searching near the northern constellation of Cygnus. It is hoped that the discovery will help resolve a decades-old debate, regarding the role of stellar companions in the formation and structure of planetary nebulae.The nebula is within a relatively small area, which is currently being monitored by NASA's Kepler planet finding mission and the light of the nebula is primarily due to the emissions from doubly ionized oxygen.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "PN G75.5+1.7",
    "name": "Soap Bubble Nebula",
    "type": "Planetary Nebula",
    "constellation": "Cygnus",
    "magnitude": 19,
    "credit": "T.A. Rector (University of Alaska Anchorage) H. Schweiker (WIYN and NOIRLab/NSF/AURA)",
    "img": 94,
    "ra": {
      "decimal": 303.8425,
      "h": 20,
      "m": 15,
      "s": 22.2
    },
    "dec": {
      "decimal": 38.04944444444444,
      "d": 38,
      "m": 2,
      "s": 58
    },
    "description": "The Soap Bubble Nebula, or PN G75.5+1.7, is a planetary nebula in the constellation Cygnus, near the Crescent Nebula (NGC 6888). It was discovered by amateur astronomer Dave Jurasevich using an Astro-Physics 160 mm refractor telescope with which he imaged the nebula on June 19, 2007 and on July 6, 2008. The nebula was later independently noted and reported to the International Astronomical Union by Keith B. Quattrocchi and Mel Helm who imaged PN G75.5+1.7 on July 17, 2008. The nebula measures 260″ in angular diameter with a central star that has a J band magnitude of 19.45.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 6210",
    "name": "Turtle Nebula",
    "type": "Planetary Nebula",
    "constellation": "Hercules",
    "magnitude": 10.133,
    "credit": "NASA/ESA/Hubble",
    "img": 95,
    "ra": {
      "decimal": 251.12299625807,
      "h": 16,
      "m": 44,
      "s": 29.5191019368
    },
    "dec": {
      "decimal": 23.79983943286,
      "d": 23,
      "m": 47,
      "s": 59.421958296
    },
    "description": "NGC 6210 is a planetary nebula located  in the constellation Hercules, approximately 5.4 ± 1.3 kly from the Sun. It is positioned about 38° above the galactic plane at a vertical distance of about 3.3 kilolight-years (1 kpc) and thus has little extinction from intervening interstellar dust. This object was first recorded as a star-like feature by Joseph Lalande on March 22, 1799. However, credit for the discovery of a nebula goes to Wilhelm Struve in 1825. John L. E. Dreyer described it as, \"a planetary nebula, very bright, very small, round, disc and border\".This nebula is \"very amorphous and irregular\" in shape, but forms a rough ellipsoid. It consists of two parts; a bright inner region filled with arches and filaments spanning 13″ × 16\", and a larger and fainter outer volume that has a pair of \"tubular\" structures. The inner region has an expansion velocity ranging over 19–24 km/s. The emission from the outer part of the nebula is only about 1% of the total.The central star has an apparent visual magnitude of 12.66 and the spectrum matches a hydrogen-rich star of type O(H). It has an estimated temperature of 65,000 K. The abundances of the nebula suggest a low initial mass for the central star, probably ~0.9 M☉. Outflow from this star has been measured with velocities of 2,180 km/s, and the estimated mass loss rate is 2.2×10−9 M☉ yr−1. There appears to be a collaminated jet feature to the northwest, suggesting the central star is ejecting material along two and possibly four such directions.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "M2-9",
    "name": "Twin Jet Nebula",
    "type": "Planetary Nebula",
    "constellation": "Ophiuchus",
    "magnitude": 14.7,
    "credit": "ESA/Hubble",
    "img": 96,
    "ra": {
      "decimal": 256.40813333333335,
      "h": 17,
      "m": 5,
      "s": 37.952
    },
    "dec": {
      "decimal": -10.142938888888889,
      "d": -10,
      "m": 8,
      "s": 34.58
    },
    "description": "Minkowski 2-9, abbreviated M2-9 (also known as Minkowski's Butterfly, Twin Jet Nebula, the Wings of a Butterfly Nebula, or just Butterfly Nebula) is a planetary nebula that was discovered by Rudolph Minkowski in 1947.  It is located about 2,100 light-years away from Earth in the direction of the constellation Ophiuchus.  This bipolar nebula takes the peculiar form of twin lobes of material that emanate from a central star.  Astronomers have dubbed this object as the Twin Jet Nebula because of the jets believed to cause the shape of the lobes. Its form also resembles the wings of a butterfly.  The nebula was imaged by the Hubble Space Telescope in the 1990s.\nThe primary component of the central binary is the hot core of a star that reached the end of its main-sequence life cycle, ejected most of its outer layers and became a red giant, and is now contracting into a white dwarf.  It is believed to have been a sun-like star early in its life.  The second, smaller star of the binary orbits very closely and may even have been engulfed by the other's expanding stellar atmosphere with the resulting interaction creating the nebula. Astronomers theorize that the gravity of one star pulls some of the gas from the surface of the other and flings it into a thin, dense disk extending into space.The nebula has inflated dramatically due to a fast stellar wind, blowing out into the surrounding disk and inflating the large, wispy hourglass-shaped wings perpendicular to the disk. These wings produce the butterfly appearance when seen in projection.  The outer shell is estimated to be about 1,200 years old (Schwarz et al. 1997).",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "SN 1572",
    "name": "Tycho's Supernova",
    "type": "Supernova Remnant",
    "constellation": "Cassiopeia",
    "magnitude": 4,
    "credit": "NASA/CXC/Rutgers/K.Eriksen et al",
    "img": 97,
    "ra": {
      "decimal": 6.339583333333334,
      "h": 0,
      "m": 25,
      "s": 21.5
    },
    "dec": {
      "decimal": 64.14083333333333,
      "d": 64,
      "m": 8,
      "s": 27
    },
    "description": "SN 1572 (Tycho's Supernova, Tycho's Nova), or B Cassiopeiae (B Cas), was a supernova of Type Ia in the constellation Cassiopeia, one of eight supernovae visible to the naked eye in historical records. It appeared in early November 1572 and was independently discovered by many individuals.\nIts supernova remnant has been observed optically but was first detected at radio wavelengths; it is often known as 3C 10, a radio-source designation, although increasingly as Tycho's supernova remnant.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 6357",
    "name": "War and Peace Nebula",
    "type": "Emission Nebula",
    "constellation": "Scorpius",
    "magnitude": 6,
    "credit": "NASA",
    "img": 98,
    "ra": {
      "decimal": 261.185,
      "h": 17,
      "m": 24,
      "s": 44.4
    },
    "dec": {
      "decimal": -34.20305555555556,
      "d": -34,
      "m": 12,
      "s": 11
    },
    "description": "NGC 6357 is a diffuse nebula near NGC 6334 in the constellation Scorpius.  The nebula contains many proto-stars shielded by dark discs of gas, and young stars wrapped in expanding \"cocoons\" or expanding gases surrounding these small stars. It is also known as the Lobster Nebula. This nebula was given the name War and Peace Nebula by the Midcourse Space Experiment scientists because of its appearance, which, in infrared images the bright, western part resembles a dove, while the eastern part looks like a skull.It is located about ~5,500 light years away from Earth.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "IC 1318",
    "name": "Sadr Region",
    "type": "Emission Nebula",
    "constellation": "Cygnus",
    "magnitude": 2.2,
    "credit": "Public Domain",
    "img": 99,
    "ra": {
      "decimal": 304.2,
      "h": 20,
      "m": 16,
      "s": 48
    },
    "dec": {
      "decimal": 41.95666666666667,
      "d": 41,
      "m": 57,
      "s": 24
    },
    "description": "The Sadr Region (also known as IC 1318 or the Gamma Cygni Nebula) is the diffuse emission nebula surrounding Sadr (γ Cygni) at the center of Cygnus's cross. The Sadr Region is one of the surrounding nebulous regions; others include the Butterfly Nebula and the Crescent Nebula. It contains many dark nebulae in addition to the emission diffuse nebulae.\nSadr itself has approximately a magnitude of 2.2. The nebulous regions around the region are also fairly bright.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 2022",
    "name": "Kissing Crescents",
    "type": "Emission Nebula",
    "constellation": "Orion",
    "magnitude": 7.4,
    "credit": "NASA/ESA/Hubble",
    "img": 100,
    "ra": {
      "decimal": 85.52579343888,
      "h": 5,
      "m": 42,
      "s": 6.1904253312
    },
    "dec": {
      "decimal": 9.08627388766,
      "d": 9,
      "m": 5,
      "s": 10.585995576
    },
    "description": "NGC 2022 is a planetary nebula in the equatorial constellation of Orion, located at a distance of 8.21 kilolight-years from the Sun. It was first observed by William Herschel on December 28, 1785, who described it as: considerably bright, nearly round, like a star with a large diameter, like an ill-defined planetary nebula. In medium-sized amateur telescopes it looks like a small grayish patch of light. It is not very bright but it is still easy to spot it in the eyepiece. Even in a telescope as small as 80mm it can just be seen using a narrowband filter such as an OIII filter as a 'fuzzy' star. The object has the shape of a prolate spheroid with a major to minor axis ratio of 1.2, an apparent size of 28″, and a halo extending out to 40″, which is about the angular diameter of Jupiter as seen from Earth.This is a double-shell planetary nebula with a wind-compressed inner shell and a more nebulous second shell. The linear radius of the inner shell is estimated at 0.326 ± 0.039 ly. It is expanding with a velocity of 28±2 km/s. The second shell is nearly circular and is expanding more slowly than the inner. The mass of the ionized elements in the planetary nebula is 0.19 M☉, or 19% of the Sun's mass. A faint outer halo consists of the remains of material ejected during the central star's asymptotic giant branch stage.NGC 2022 nebula lies 11° away from the Galactic Plane, which position suggests it was formed from a low-mass star. The elemental abundances are similar to those in the Sun, although carbon is about 50% higher and sulfur is a factor of two lower. The central star of this nebula has a visual magnitude of 15.92, a temperature of 122,000 K, and is radiating 852 times the luminosity of the Sun from a photosphere that has only 6.55% of the Sun's radius.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 6818",
    "name": "Little Gem Nebula",
    "type": "Emission Nebula",
    "constellation": "Sagittarius",
    "magnitude": 10,
    "credit": "NASA/ESA/Hubble",
    "img": 101,
    "ra": {
      "decimal": 295.99175833333334,
      "h": 19,
      "m": 43,
      "s": 58.022
    },
    "dec": {
      "decimal": -14.153733333333333,
      "d": -14,
      "m": 9,
      "s": 13.44
    },
    "description": "The Little Gem Nebula or NGC 6818 is a planetary nebula located  in the constellation of Sagittarius. It has magnitude 10 and oval diameter of 15 to 22 arcseconds with a 15th magnitude central star.\nIt was discovered by William Herschel in 1787.\nNGC 6818 is located in the constellation of Sagittarius (The Archer), roughly 6000 light-years away from Earth. The glow of the cloud is just over half a light-year across.\nWhen stars like the Sun are near end of life, they send their outer layers into space to create glowing clouds of gas, a planetary nebulae. This ejection of mass is uneven, and planetary nebulae can have complex shapes. NGC 6818 shows knotty filament-like structures and distinct layers of material, with a bright and enclosed central bubble surrounded by a larger, more diffuse cloud.\nScientists believe that the stellar wind from the central star propels the outflowing material, forming the elongated shape of NGC 6818. As this stellar wind moves through the slower-moving cloud it creates particularly bright spots in the bubble's outer layers.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "Sh2-274",
    "name": "Medusa Nebula",
    "type": "Planetary Nebula",
    "constellation": "Gemini",
    "magnitude": 15,
    "credit": "ESO",
    "img": 102,
    "ra": {
      "decimal": 112.26129027258,
      "h": 7,
      "m": 29,
      "s": 2.7096654192
    },
    "dec": {
      "decimal": 13.24682987644,
      "d": 13,
      "m": 14,
      "s": 48.587555184
    },
    "description": "The Medusa Nebula is a planetary nebula in the constellation of Gemini. It is also known as Abell 21 and Sharpless 2-274. It was originally discovered in 1955 by University of California, Los Angeles astronomer George O. Abell, who classified it as an old planetary nebula. Until the early 1970s, the nebula was thought to be a supernova remnant. With the computation of expansion velocities and the thermal character of the radio emission, Soviet astronomers in 1971 concluded that it was most likely a planetary nebula. As the nebula is so large, its surface brightness is very low, with surface magnitudes of between +15.99 and +25 reported.The central star of the planetary nebula is an PG 1159 star.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 2174",
    "name": "Monkey Head Nebula",
    "type": "Emission Nebula",
    "constellation": "Orion",
    "magnitude": 6.8,
    "credit": "NASA/ESA/Hubble",
    "img": 103,
    "ra": {
      "decimal": 92.425,
      "h": 6,
      "m": 9,
      "s": 42
    },
    "dec": {
      "decimal": 20.5,
      "d": 20,
      "m": 30,
      "s": 0
    },
    "description": "NGC 2174 (also known as Monkey Head Nebula) is an H II emission nebula located in the constellation Orion and is associated with the open star cluster NGC 2175. It is thought to be located about 6,400 light-years away from Earth.  The nebula may have formed through hierarchical collapse.There is some equivocation in the use of the identifiers NGC 2174 and NGC 2175.  These may apply to the entire nebula, to its brightest knot, or to the star cluster it includes.  Burnham's Celestial Handbook lists the entire nebula as 2174/2175 and does not mention the star cluster. The NGC Project (working from the original descriptive notes) assigns NGC 2174 to the prominent knot at J2000 06h 09m 23.7s, +20° 39′ 34″ and NGC 2175 to the entire nebula, and by extension to the star cluster. Simbad uses NGC 2174 for the nebula and NGC 2175 for the star cluster. Glowing gas and dark dust does not survive well in the Monkey Head Nebula. Young Stars near the center of the nebula generate stellar winds and high energy radiation that causes the Nebula's material to shift into complex shapes. The nebula is primarily composed of hydrogen which glows at infrared wavelengths due to the radiation.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 3576",
    "name": "Statue Of Liberty Nebula",
    "type": "Emission Nebula",
    "constellation": "Carina",
    "magnitude": 14,
    "credit": "Public Domain",
    "img": 104,
    "ra": {
      "decimal": 167.9575,
      "h": 11,
      "m": 11,
      "s": 49.8
    },
    "dec": {
      "decimal": -61.303888888888885,
      "d": -61,
      "m": 18,
      "s": 14
    },
    "description": "NGC 3576 is a bright emission nebula in the Sagittarius arm of the galaxy a few thousand light-years away from the Eta Carinae nebula. It is also approximately 100 light years across and 9000 light-years away from Earth. This nebula even received six different classification numbers. Currently, astronomers call the entire nebula NGC 3576. A popular nickname is \"The Statue of Liberty Nebula\" because of the distinctive shape in the middle of the nebula. Discovered by John Frederick William Herschel on 16 March 1834. The name was first suggested in 2009 by Dr. Steve Mazlin, a member of Star Shadows Remote Observatory (SSRO). Within the nebula, episodes of star formation are thought to contribute to the complex and suggestive shapes. Powerful winds from the nebula's embedded, young, massive stars shape the looping filaments.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 5189",
    "name": "Spiral Planetary Nebula",
    "type": "Planetary Nebula",
    "constellation": "Musca",
    "magnitude": 8.2,
    "credit": "NASA/ESA/Hubble",
    "img": 105,
    "ra": {
      "decimal": 203.38699183926,
      "h": 13,
      "m": 33,
      "s": 32.8780414224
    },
    "dec": {
      "decimal": -65.97417817452,
      "d": -65,
      "m": 58,
      "s": 27.041428272
    },
    "description": "NGC 5189 (Gum 47, IC 4274, nicknamed Spiral Planetary Nebula) is a planetary nebula in the constellation Musca. It was discovered by James Dunlop on 1 July 1826, who catalogued it as Δ252. For many years, well into the 1960s, it was thought to be a bright emission nebula. It was  Karl Gordon Henize in 1967 who first described NGC 5189 as quasi-planetary based on its spectral emissions.\nSeen through the telescope it seems to have an S shape, reminiscent of a barred spiral galaxy. The S shape, together with point-symmetric knots in the nebula, have for a long time hinted to astronomers that a binary central star is present. \nThe Hubble Space Telescope imaging analysis showed that this S shape structure is indeed two dense low-ionization regions: one moving toward the north-east and another one moving toward the south-west of the nebula, which could be a result of a recent outburst from the central star. Observations with the Southern African Large Telescope have finally found a white dwarf companion in a 4.04 day orbit around the rare low-mass Wolf-Rayet type central star of NGC 5189. NGC 5189 is estimated to be 546 parsecs or 1,780 light years away from Earth. Other measurements have yielded results up to 900 parsecs (~3000 light-years)",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 6369",
    "name": "Little Ghost Nebula",
    "type": "Planetary Nebula",
    "constellation": "Ophiuchus",
    "magnitude": 12,
    "credit": "NASA/ESA/Hubble",
    "img": 106,
    "ra": {
      "decimal": 262.33523604621,
      "h": 17,
      "m": 29,
      "s": 20.4566510904
    },
    "dec": {
      "decimal": -23.75965883868,
      "d": -23,
      "m": 45,
      "s": 34.771819248
    },
    "description": "Little Ghost Nebula, also known as NGC 6369, is a planetary nebula in the constellation Ophiuchus. It was discovered by William Herschel.Round and planet-shaped, the nebula is also relatively faint. The high energy radiation from the central white dwarf causes the surrounding nebula to emit light. The nebula's main ring structure is about a light-year across and the glow from ionized oxygen, hydrogen, and nitrogen atoms are colored blue, green, and red respectively.\nThe Little Ghost Nebula should not be confused with the Ghost Nebula (Sh2-136) or the Ghost Head Nebula (NGC 2080).\nThe central star of the planetary nebula has a spectral type of [WO3], indicating a spectrum similar to that of an oxygen-rich Wolf–Rayet star. An analysis of Gaia data suggests that the it may be a binary system. The central star was monitored by Kepler, but it was not found to be variable.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 6741",
    "name": "Phantom Streak Nebula",
    "type": "Planetary Nebula",
    "constellation": "Aquila",
    "magnitude": 11,
    "credit": "NASA/ESA/Hubble",
    "img": 107,
    "ra": {
      "decimal": 285.65458333333333,
      "h": 19,
      "m": 2,
      "s": 37.1
    },
    "dec": {
      "decimal": 0.44908333333333333,
      "d": "-00",
      "m": 26,
      "s": 56.7
    },
    "description": "NGC 6741, also known as the Phantom Streak Nebula, is located about 7000 light-years away in the constellation of Aquila (the Eagle). NGC 6741 is classed as a planetary nebula, though no planets are responsible for this billowy cloud; the term came about in the 18th century because the round gas shells resembled the Solar System's outer giant planets in astronomers' telescopes. Although fairly bright, this object appears very small through a typical telescope and was missed by early surveyors of the skies and only spotted in 1882 by Edward Charles Pickering.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 2237",
    "name": "Rosette Nebula",
    "type": "Emission Nebula",
    "constellation": "Monoceros",
    "magnitude": 9,
    "credit": "Public Domain",
    "img": 108,
    "ra": {
      "decimal": 98.1115,
      "h": 6,
      "m": 32,
      "s": 26.76
    },
    "dec": {
      "decimal": 4.793638888888888,
      "d": 4,
      "m": 47,
      "s": 37.1
    },
    "description": "The Rosette Nebula (also known as Caldwell 49) is an H II region located near one end of a giant molecular cloud in the Monoceros region of the Milky Way Galaxy. The open cluster NGC 2244 (Caldwell 50) is closely associated with the nebulosity, the stars of the cluster having been formed from the nebula's matter.\nThe complex has the following New General Catalogue (NGC) designations:\n\nNGC 2237 – Part of the nebulous region (Also used to denote whole nebula)\nNGC 2238 – Part of the nebulous region\nNGC 2239 – Part of the nebulous region (Discovered by John Herschel)\nNGC 2244 – The open cluster within the nebula (Discovered by John Flamsteed in 1690)\nNGC 2246 – Part of the nebulous regionThe cluster and nebula lie at a distance of 5,000 light-years from Earth and measure roughly 130 light years in diameter. The radiation from the young stars excites the atoms in the nebula, causing them to emit radiation themselves producing the emission nebula we see. The mass of the nebula is estimated to be around 10,000 solar masses.\nA survey of the nebula with the Chandra X-ray Observatory has revealed the presence of numerous new-born stars inside optical Rosette Nebula and studded within a dense molecular cloud. Altogether, approximately 2500 young stars lie in this star-forming complex, including the massive O-type stars HD 46223 and HD 46150, which are primarily responsible for blowing the ionized bubble.\nMost of the ongoing star-formation activity is occurring in the dense molecular cloud to the south east of the bubble.A diffuse X-ray glow is also seen between the stars in the bubble, which has been attributed to a super-hot plasma with temperatures ranging from 1 to 10 million K.\nThis is significantly hotter than the 10,000 K plasmas seen in HII regions, and is likely attributed to the shock-heated winds from the massive O-type stars.\nOn April 16, 2019 the Oklahoma Legislature passed HB1292 making the Rosette Nebula as the official state astronomical object. Oklahoma Governor Kevin Stitt signed it into law April 22, 2019.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 2467",
    "name": "Skull and Crossbones Nebula",
    "type": "Emission Nebula",
    "constellation": "Puppis",
    "magnitude": 7.1,
    "credit": "ESO",
    "img": 109,
    "ra": {
      "decimal": 118.07708333333333,
      "h": 7,
      "m": 52,
      "s": 18.5
    },
    "dec": {
      "decimal": -26.428055555555556,
      "d": -26,
      "m": 25,
      "s": 41
    },
    "description": "NGC 2467, nicknamed the \"Skull and Crossbones Nebula\", is a star-forming region whose appearance has occasionally also been likened to that of a colorful mandrill. It includes areas where large clouds of hydrogen gas incubate new stars. This region was one of the areas featured in the book Hubble's Universe: Greatest Discoveries and Latest Images by Terence Dickinson.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "Westerhout 50",
    "name": "Manatee Nebula",
    "type": "Supernova Remnant",
    "constellation": "Aquila",
    "magnitude": 7,
    "credit": "NRAO/AUI/NSF, K. Golap, M. Goss",
    "img": 110,
    "ra": {
      "decimal": 288.0833333333333,
      "h": 19,
      "m": 12,
      "s": 20
    },
    "dec": {
      "decimal": 4.916666666666667,
      "d": 4,
      "m": 55,
      "s": 0
    },
    "description": "Westerhout 50 (W50) or SNR G039.7-02.0, also referred to as the Manatee Nebula,  is a supernova remnant located in the constellation Aquila, about 18,000 light years away. In its centre lies the micro-quasar SS 433, whose jets are distorting the remnant's shell. Most likely W50 and SS 433 are related objects, remnants from a supernova which occurred about 20,000 years ago.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "HD 44179",
    "name": "Red Rectangle Nebula",
    "type": "Protoplanetary Nebula",
    "constellation": "Monoceros",
    "magnitude": 9.02,
    "credit": "Judy Schmidt",
    "img": 111,
    "ra": {
      "decimal": 94.99257729,
      "h": 6,
      "m": 19,
      "s": 58.2185496
    },
    "dec": {
      "decimal": -10.637418352222221,
      "d": -10,
      "m": 38,
      "s": 14.706068
    },
    "description": "The Red Rectangle Nebula, so called because of its red color and unique rectangular shape, is a protoplanetary nebula in the Monoceros constellation.  Also known as HD 44179, the nebula was discovered in 1973 during a rocket flight associated with the AFCRL Infrared Sky Survey called Hi Star.  The binary system at the center of the nebula was first discovered by Robert Grant Aitken in 1915.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "M57",
    "name": "Ring Nebula",
    "type": "Planetary Nebula",
    "constellation": "Lyra",
    "magnitude": 8.8,
    "credit": "NASA/ESA/Hubble",
    "img": 112,
    "ra": {
      "decimal": 283.3961625,
      "h": 18,
      "m": 53,
      "s": 35
    },
    "dec": {
      "decimal": 33.029175,
      "d": 33,
      "m": 1,
      "s": 45
    },
    "description": "The Ring Nebula (also catalogued as Messier 57, M57 and NGC 6720) is a planetary nebula in the mildly northern constellation of Lyra. Such a nebula is formed when a star, during the last stages of its evolution before becoming a white dwarf, expels a vast luminous envelope of ionized gas into the surrounding interstellar space.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "Sh2-279",
    "name": "Running Man Nebula",
    "type": "Planetary Nebula",
    "constellation": "Orion",
    "magnitude": 7,
    "credit": "Public Domain",
    "img": 113,
    "ra": {
      "decimal": 83.8175,
      "h": 5,
      "m": 35,
      "s": 16.2
    },
    "dec": {
      "decimal": -4.785277777777778,
      "d": -4,
      "m": 47,
      "s": 7
    },
    "description": "Sh2-279 (alternatively designated S279 or Sharpless 279) is an HII region and bright nebulae that includes a reflection nebula located in the constellation Orion. It is the northernmost part of the asterism known as Orion's Sword, lying 0.6° north of the Orion Nebula. The reflection nebula embedded in \nSh2-279 is popularly known as the Running Man Nebula.Sh2-279 comprises three NGC nebulae, NGC 1973, NGC 1975, and NGC 1977 that are divided by darker nebulous regions. It also includes the open cluster NGC 1981. The brightest nebulosity, later listed as NGC 1977, was discovered by William Herschel in 1786.  He catalogued it as \"H V 30\" and described \"!! 42 Orionis and neb[ula]\". The two smaller reflection nebulae were first noted by German astronomer Heinrich Louis d'Arrest, NGC 1973 in 1862 and NGC 1975 in 1864. All three were included in the New General Catalogue in 1888. The designation NGC 1977 is used in various sources for the reflection area around 42 Orionis (the south-east portion of the reflection nebula), for the entire reflection nebula (including NGC 1973 and NGC 1975), or for the whole nebula complex.This whole region in Orion's Sword was also later catalogued as Orion 1c.  In 1966, van den Bergh distinguished the weak clustering of reflection nebulae that includes Sh2-279 as Ori R2. Every reflection nebula appearing within the Sharpless catalogue was first identified on blue plates of the Palomar Sky Survey, and then double checked against the red plates to eliminate possible plate faults. Van den Berg found that there was a strong concentration of new T Tauri stars around the Orion Nebula, tapering off into a tail approaching Sh2-279.The Running Man Nebula is a popular target for amateur astrophotographers, as it lies close to the Orion Nebula and has many nearby guide stars. The outline of the running man shows up primarily in photographs; it is difficult to perceive visually through telescopes, though the reflection nebula itself is visible in small to medium apertures in dark skies.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "IC 5070",
    "name": "Pelican Nebula",
    "type": "Emission Nebula",
    "constellation": "Cygnus",
    "magnitude": 8,
    "credit": "Public Domain",
    "img": 114,
    "ra": {
      "decimal": 312.75,
      "h": 20,
      "m": 51,
      "s": 0
    },
    "dec": {
      "decimal": 44.36666666666667,
      "d": 44,
      "m": 22,
      "s": 0
    },
    "description": "The Pelican Nebula (also known as IC 5070 and IC 5067) is an H II region associated with the North America Nebula in the constellation Cygnus. The gaseous contortions of this emission nebula bear a resemblance to a pelican, giving rise to its name. The Pelican Nebula is located nearby first magnitude star Deneb, and is divided from its more prominent neighbour, the North America Nebula, by a foreground molecular cloud filled with dark dust. Both are part of the larger H II region of Westerhout 40.The Pelican is much studied because it has a particularly active mix of star formation and evolving gas clouds. The light from young energetic stars is slowly transforming cold gas to hot and causing an ionization front gradually to advance outward. Particularly dense filaments of cold gas are seen to still remain, and among these are found two jets emitted from the Herbig–Haro object 555. Millions of years from now this nebula might no longer be known as the Pelican, as the balance and placement of stars and gas will leave something that appears completely different.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "IC 2177",
    "name": "Seagull Nebula",
    "type": "Emission Nebula",
    "constellation": "Monoceros",
    "magnitude": 15,
    "credit": "ESO",
    "img": 115,
    "ra": {
      "decimal": 106.10416666666667,
      "h": 7,
      "m": 4,
      "s": 25
    },
    "dec": {
      "decimal": -10.455,
      "d": -10,
      "m": 27,
      "s": 18
    },
    "description": "IC 2177 is a region of nebulosity that lies along the border between the constellations Monoceros and Canis Major. It is a roughly circular H II region centered on the Be star HD 53367. This nebula was discovered by Welsh amateur astronomer Isaac Roberts and was described by him as \"pretty bright, extremely large, irregularly round, very diffuse.\"The name Seagull Nebula is sometimes applied by amateur astronomers to this emission region, although it more properly includes the neighboring regions of star clusters, dust clouds and reflection nebulae. This latter region includes the open clusters NGC 2335 and NGC 2343.NGC 2327 is located in IC 2177. It is also known as the Seagull's Head, due to its larger presence in the Seagull nebula.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "Shapley 1",
    "name": "Fine Ring Nebula",
    "type": "Planetary Nebula",
    "constellation": "Norma",
    "magnitude": 12,
    "credit": "ESO",
    "img": 116,
    "ra": {
      "decimal": 237.928125,
      "h": 15,
      "m": 51,
      "s": 42.75
    },
    "dec": {
      "decimal": -51.52513888888889,
      "d": -51,
      "m": 31,
      "s": 30.5
    },
    "description": "Shapley 1 (Sp 1 or PLN 329+2.1)  is an annular planetary nebula in the constellation of Norma with a magnitude of +12.6. As viewed from Earth, it is peculiar in that it seems to be a non-bipolar, torus-shaped planetary nebula. However, it is thought that this is due to the viewpoint of looking directly down on a binary system whose orbit is perpendicular to Earth.Discovered in 1936 by Harlow Shapley, it is approximately 4900 light years from Earth, and is around 8700 years old. At the center of the nebula is a magnitude 14 white dwarf star. It has an angular diameter of 1.1 arc minutes,  which makes it about one-third (.32) of a light year across.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "B77",
    "name": "Dark Horse Nebula",
    "type": "Dark Nebula",
    "constellation": "Ophiuchus",
    "magnitude": 5,
    "credit": "ESO/Y. Beletsky",
    "img": 117,
    "ra": {
      "decimal": 260.25,
      "h": 17,
      "m": 21,
      "s": 0
    },
    "dec": {
      "decimal": -21.116666666666667,
      "d": -21,
      "m": 7,
      "s": 0
    },
    "description": "The Dark Horse Nebula or Great Dark Horse (sometimes called the Prancing Horse) is a large dark nebula that, from Earth's perspective, obscures part of the upper central bulge of the Milky Way. The Dark Horse lies in the equatorial constellation Ophiuchus (the Serpent Bearer), near its borders with the more famous constellations Scorpius and Sagittarius. It is a large, visible feature of the Milky Way's Great Rift, uniting several individually catalogued dark nebulae, including the Pipe Nebula. It is visible from Earth only on clear moonless nights without light pollution and with low humidity.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 246",
    "name": "Skull Nebula",
    "type": "Planetary Nebula",
    "constellation": "Cetus",
    "magnitude": 11.76,
    "credit": "ESO",
    "img": 118,
    "ra": {
      "decimal": 11.76392514234,
      "h": 0,
      "m": 47,
      "s": 3.3420341616
    },
    "dec": {
      "decimal": -11.87193642391,
      "d": -11,
      "m": 52,
      "s": 18.971126076
    },
    "description": "NGC 246 (also known as the Skull Nebula or Caldwell 56) is a planetary nebula in the constellation Cetus. The nebula and the stars associated with it are listed in several catalogs, as summarized by the SIMBAD database. It is roughly 1,600 light-years away. The nebula's central star is the 12th magnitude white dwarf HIP 3678.\nAmong some amateur astronomers, NGC 246 is known as the \"Pac-Man Nebula\" because of the arrangement of its central stars and the surrounding star field.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 6537",
    "name": "Red Spider Nebula",
    "type": "Planetary Nebula",
    "constellation": "Sagittarius",
    "magnitude": 13,
    "credit": "ESA/G. Mellema",
    "img": 119,
    "ra": {
      "decimal": 271.3046,
      "h": 18,
      "m": 5,
      "s": 13.104
    },
    "dec": {
      "decimal": -19.84302222222222,
      "d": -19,
      "m": 50,
      "s": 34.88
    },
    "description": "The Red Spider Nebula (also catalogued as NGC 6537) is a planetary nebula located near the heart of the Milky Way, in the northwest of  the constellation Sagittarius. The nebula has a prominent two-lobed shape, possibly due to a binary companion or magnetic fields and has an S-shaped symmetry of the lobes – the lobes opposite each other appear similar. This is believed to be due to the presence of a companion to the central white dwarf. However, the gas walls of the two lobed structures are not at all smooth, but rather are rippled in a complex way.The central white dwarf, the remaining compact core of the original star, produces a powerful and hot (≈10,000 K) wind blowing with a speed of 300 kilometers per second, which has generated waves 100 billion kilometres high. The waves are generated by supersonic shocks formed when the local gas is compressed and heated in front of the rapidly expanding lobes. Atoms caught in the shocks radiate a visible light. These winds are what give this nebula its unique 'spider' shape and also contribute to the expansion of the nebula.The star at the center of the Red Spider Nebula is surrounded by a dust shell making its exact properties hard to determine.  Its surface temperature is probably 150,000–250,000 K, although a temperature of 340,000 K or even 500,000 K is not ruled out, making it among the hottest white dwarf stars known.\nThe Red Spider Nebula lies near the constellation of Sagittarius. Its distance has been variously estimated as 1,900 light-years or, more likely, 3,000–8,000 light-years.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 7000",
    "name": "North America Nebula",
    "type": "Emission Nebula",
    "constellation": "Cygnus",
    "magnitude": 4,
    "credit": "Public Domain",
    "img": 120,
    "ra": {
      "decimal": 314.6958333333333,
      "h": 20,
      "m": 58,
      "s": 47
    },
    "dec": {
      "decimal": 44.330000000000005,
      "d": 44,
      "m": 19,
      "s": 48
    },
    "description": "The North America Nebula (NGC 7000 or Caldwell 20) is an emission nebula in the constellation Cygnus, close to Deneb (the tail of the swan and its brightest star). The shape of the nebula resembles that of the continent of North America, complete with a prominent Gulf of Mexico.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 7252",
    "name": "Atoms for Peace Galaxy",
    "type": "Peculiar Galaxy",
    "constellation": "Aquarius",
    "magnitude": 12.7,
    "credit": "NASA/ESA/Hubble",
    "img": 121,
    "ra": {
      "decimal": 335.18656175402,
      "h": 22,
      "m": 20,
      "s": 44.7748209648
    },
    "dec": {
      "decimal": -24.6783081995,
      "d": -24,
      "m": 40,
      "s": 41.9095182
    },
    "description": "NGC 7252 is a peculiar galaxy resulting from an interaction between two galaxies that started a billion years ago. It is located 220 million light years away in the constellation Aquarius. It is also called Atoms for Peace Galaxy, a nickname which comes from its loop-like structure, made of stars, that resembles a diagram of an electron orbiting an atomic nucleus.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "Arp 273",
    "name": "Cosmic Seashell",
    "type": "Spiral Galaxy",
    "constellation": "Andromeda",
    "magnitude": 13.7,
    "credit": "NASA/ESA/Hubble",
    "img": 122,
    "ra": {
      "decimal": 35.36960977733,
      "h": 2,
      "m": 21,
      "s": 28.7063465592
    },
    "dec": {
      "decimal": 39.37558926756,
      "d": 39,
      "m": 22,
      "s": 32.121363216
    },
    "description": "Arp 273 is a pair of interacting galaxies, 300 million light years away in the constellation Andromeda. It was first described in the Atlas of Peculiar Galaxies, compiled by Halton Arp in 1966. The larger of the spiral galaxies, known as UGC 1810, is about five times more massive than the smaller galaxy. It has a disc that is tidally distorted into a rose-like shape by the gravitational pull of the companion galaxy below it, known as UGC 1813. The smaller galaxy shows distinct signs of active star formation at its nucleus, and \"it is thought that the smaller galaxy has actually passed through the larger one.\"",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "MCG-05-33-005",
    "name": "Seashell Galaxy",
    "type": "Elliptical Galaxy",
    "constellation": "Centaurus",
    "magnitude": 18,
    "credit": "ESO",
    "img": 123,
    "ra": {
      "decimal": 206.8466102901,
      "h": 13,
      "m": 47,
      "s": 23.186469624
    },
    "dec": {
      "decimal": -30.41783101497,
      "d": -30,
      "m": 25,
      "s": 4.191653892
    },
    "desccred": "https://oxfordreference.com/",
    "description": "An unusually shaped galaxy about 280 million l.y. away in Centaurus, interacting with the galaxy NGC 5291. The Seashell has no NGC number of its own. Both galaxies are part of a cluster, the brightest member of which is IC 4329."
  },
  {
    "label": "LMC",
    "name": "Large Magellanic Cloud",
    "type": "Spiral Galaxy",
    "constellation": "Dorado",
    "magnitude": 0.9,
    "credit": "NASA/ESA/Hubble",
    "img": 124,
    "ra": {
      "decimal": 80.89416666666666,
      "h": 5,
      "m": 23,
      "s": 34.6
    },
    "dec": {
      "decimal": -69.75611111111111,
      "d": -69,
      "m": 45,
      "s": 22
    },
    "description": "The Large Magellanic Cloud (LMC), or Nubecula Major is a satellite galaxy of the Milky Way. At a distance of around 50 kiloparsecs (≈160,000 light-years), the LMC is the second- or third-closest galaxy to the Milky Way, after the Sagittarius Dwarf Spheroidal (~16 kpc) and the possible dwarf irregular galaxy known as the Canis Major Overdensity. Based on readily visible stars and a mass of approximately 10 billion solar masses, the diameter of the LMC is about 14,000 light-years (4.3 kpc). It is roughly a hundredth as massive as the Milky Way and is the fourth-largest galaxy in the Local Group, after the Andromeda Galaxy (M31), the Milky Way and the Triangulum Galaxy (M33).\nThe LMC is classified as a Magellanic spiral. It contains a stellar bar that is geometrically off center, suggesting that it was a barred dwarf spiral galaxy before its spiral arms were disrupted, likely by tidal interactions from the Small Magellanic Cloud (SMC) and the Milky Way's gravity.With a declination of about −70°, the LMC is visible as a faint \"cloud\" from the southern hemisphere of the Earth and from as far north as 20° N. It straddles the constellations Dorado and Mensa and has an apparent length of about 10° to the naked eye, 20 times the Moon's diameter, from dark sites away from light pollution.The Milky Way and the LMC are predicted to merge in approximately 2.4 billion years.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "UGC 166",
    "name": "I Zwicky 18",
    "type": "Dwarf Galaxy",
    "constellation": "Ursa Major",
    "magnitude": 16,
    "credit": "NASA/ESA/Hubble",
    "img": 125,
    "ra": {
      "decimal": 4.39935782556,
      "h": 0,
      "m": 17,
      "s": 35.8458781344
    },
    "dec": {
      "decimal": 30.20488416092,
      "d": 30,
      "m": 12,
      "s": 17.582979312
    },
    "description": "I Zwicky 18 is a blue compact dwarf galaxy located about 59 million light years away in the constellation Ursa Major. The galaxy was first identified by Swiss astronomer Fritz Zwicky in a 1930s photographic survey of galaxies.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 3627",
    "name": "Leo Triplet",
    "type": "Spiral Galaxy",
    "constellation": "Leo",
    "magnitude": 8.9,
    "credit": "NASA/ESA/Hubble",
    "img": 126,
    "ra": {
      "decimal": 170.0626083,
      "h": 11,
      "m": 20,
      "s": 15
    },
    "dec": {
      "decimal": 12.9912889,
      "d": 12,
      "m": 59,
      "s": 30
    },
    "description": "The Leo Triplet (also known as the M66 Group) is a small group of galaxies about 35 million light-years away in the constellation Leo.  This galaxy group consists of the spiral galaxies M65, M66, and NGC 3628.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 4622",
    "name": "Backward Galaxy",
    "type": "Spiral Galaxy",
    "constellation": "Centaurus",
    "magnitude": 12.6,
    "credit": "NASA/ESA/Hubble",
    "img": 127,
    "ra": {
      "decimal": 190.65678210336,
      "h": 12,
      "m": 42,
      "s": 37.6277048064
    },
    "dec": {
      "decimal": -40.74421126041,
      "d": -40,
      "m": 44,
      "s": 39.160537476
    },
    "description": "NGC 4622 is a face-on unbarred spiral galaxy with a very prominent ring structure located in the constellation Centaurus. The galaxy is a member of the Centaurus Cluster.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 4826",
    "name": "Evil Eye Galaxy",
    "type": "Spiral Galaxy",
    "constellation": "Coma Berenices",
    "magnitude": 8.52,
    "credit": "Judy Schmidt",
    "img": 128,
    "ra": {
      "decimal": 194.1820667,
      "h": 12,
      "m": 56,
      "s": 43
    },
    "dec": {
      "decimal": 21.6826583,
      "d": 21,
      "m": 40,
      "s": 58
    },
    "description": "The Black Eye Galaxy (also called Sleeping Beauty Galaxy or Evil Eye Galaxy and designated Messier 64, M64, or NGC 4826) is a relatively isolated spiral galaxy 17 million light-years away in the mildly northern constellation of Coma Berenices. It was discovered by Edward Pigott in March 1779, and independently by Johann Elert Bode in April of the same year, as well as by Charles Messier the next year. A dark band of absorbing dust partially in front of its bright nucleus gave rise to its nicknames of the \"Black Eye\", \"Evil Eye\", or \"Sleeping Beauty\" galaxy. M64 is well known among amateur astronomers due to its form in small telescopes and visibility across inhabited latitudes.\nThis galaxy is inclined 60° to the line-of-sight and has a position angle of 112°. At the distance of this galaxy, it has a linear scale of 65 ly (20 pc) per arcsecond. The morphological classification in the De Vaucouleurs system is (R)SA(rs)ab, where the '(R)' indicates an outer ring-like structure, 'SA' denotes a non-barred spiral, '(rs)' means a transitional inner ring/spiral structure, and 'ab' says the spiral arms are fairly tightly wound. Ann et al. (2015) gave it a class of SABa, suggesting a weakly barred spiral galaxy with tightly wound arms.\nM64 is a type 2 Seyfert galaxy with an HII/LINER nucleus. The central region is a weak source of radio emission. A soft X-ray source has been detected at the nucleus, which is most likely coming from the circumnuclear region rather than directly from an active galactic nucleus. There is an inner disk of molecular gas that is truncated at a radius of 2,300 ly (700 pc). At present, the non-rotational motions of this disk do not significantly feed the core, but the disk does produce a vigorous rate of star formation, with also approximately 100 billion stars inside the galaxy. There is also evidence of a recent large inflow of mass.The interstellar medium of Messier 64 consists of two counter-rotating disks that are approximately equal in mass. The inner disk contains the prominent dust lanes of the galaxy. The stellar population of the galaxy exhibits no measurable counter-rotation. Possible formation scenarios include a merger with a gas-rich satellite galaxy in a retrograde orbit, or the continued accretion of gas clouds from the intergalactic medium. It has a diameter of 54,000 ly (17 kpc).\n\n",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 5128",
    "name": "Centaurus A",
    "type": "Elliptical Or Lenticular Galaxy",
    "constellation": "Centaurus",
    "magnitude": 7,
    "credit": "Public Domain",
    "img": 129,
    "ra": {
      "decimal": 201.3625,
      "h": 13,
      "m": 25,
      "s": 27
    },
    "dec": {
      "decimal": -43.01888888888889,
      "d": -43,
      "m": 1,
      "s": 8
    },
    "description": "Centaurus A (also known as NGC 5128 or Caldwell 77) is a galaxy in the constellation of Centaurus. It was discovered in 1826 by Scottish astronomer James Dunlop from his home in Parramatta, in New South Wales, Australia. There is considerable debate in the literature regarding the galaxy's fundamental properties such as its Hubble type (lenticular galaxy or a giant elliptical galaxy) and distance (10–16 million light-years). NGC 5128 is one of the closest radio galaxies to Earth, so its active galactic nucleus has been extensively studied by professional astronomers. The galaxy is also the fifth-brightest in the sky, making it an ideal amateur astronomy target. It is only visible from the southern hemisphere and low northern latitudes.\nThe center of the galaxy contains a supermassive black hole with a mass of 55 million solar masses, which ejects a relativistic jet that is responsible for emissions in the X-ray and radio wavelengths.  By taking radio observations of the jet separated by a decade, astronomers have determined that the inner parts of the jet are moving at about half of the speed of light. X-rays are produced farther out as the jet collides with surrounding gases, resulting in the creation of highly energetic particles. The X-ray jets of Centaurus A are thousands of light-years long, while the radio jets are over a million light-years long.As in other starburst galaxies, a galactic collision is suspected to be responsible for an intense burst of star formation. Models have suggested that Centaurus A was a large elliptical galaxy that collided with a smaller spiral galaxy, with which it will eventually merge. For that reason, the galaxy has been of particular interest to astronomers for years. While collisions of spiral galaxies are relatively common, the effects of a collision between an elliptical and a spiral galaxy are not fully understood.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "Messier 81",
    "name": "Bode's Galaxy",
    "type": "Spiral Galaxy",
    "constellation": "Ursa Major",
    "magnitude": 6.9,
    "credit": "NASA/ESA/Hubble",
    "img": 130,
    "ra": {
      "decimal": 148.8882208,
      "h": 9,
      "m": 55,
      "s": 33
    },
    "dec": {
      "decimal": 69.0652944,
      "d": 69,
      "m": 3,
      "s": 55
    },
    "description": "Messier 81 (also known as NGC 3031 or Bode's Galaxy) is a grand design spiral galaxy about 12 million light-years away, with a diameter of 90,000 light years, in the constellation Ursa Major. Due to its proximity to our galaxy, large size, and active galactic nucleus (which harbors a 70 million M☉supermassive black hole), Messier 81 has been studied extensively by professional astronomers. The galaxy's large size and relatively high brightness also makes it a popular target for amateur astronomers. In late February 2022, astronomers reported that M81 may be the source of FRB 20200120E, a repeating fast radio burst.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 4567, NGC 4568",
    "name": "Butterfly Galaxies",
    "type": "Interacting Galaxy",
    "constellation": "Virgo",
    "magnitude": 10.9,
    "credit": "Judy Schmidt",
    "img": 131,
    "ra": {
      "decimal": 189.14291666666668,
      "h": 12,
      "m": 36,
      "s": 34.3
    },
    "dec": {
      "decimal": 11.238055555555555,
      "d": 11,
      "m": 14,
      "s": 17
    },
    "description": "NGC 4567 and NGC 4568 (nicknamed the Butterfly Galaxies or Siamese Twins) are a set of unbarred spiral galaxies about 60 million light-years away in the constellation Virgo. They were both discovered by William Herschel in 1784. They are part of the Virgo Cluster of galaxies. \nThese galaxies are in the process of colliding and merging with each other, as studies of their distributions of neutral and molecular hydrogen show, with the highest star-formation activity in the part where they overlap. However, the system is still in an early phase of interaction.Only one supernova (SN 2004cc) was observed in the Butterfly Galaxies  until March 31, 2020, when the Zwicky Transient Facility detected the rapidly-rising SN 2020fqv in NGC 4568.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "ESO 350-40",
    "name": "Cartwheel Galaxy",
    "type": "Lenticular Galaxy",
    "constellation": "Sculptor",
    "magnitude": 15.2,
    "credit": "NASA/ESA/Hubble",
    "img": 132,
    "ra": {
      "decimal": 9.42130549683,
      "h": 0,
      "m": 37,
      "s": 41.1133192392
    },
    "dec": {
      "decimal": -33.71625419493,
      "d": -33,
      "m": 42,
      "s": 58.515101748
    },
    "description": "The Cartwheel Galaxy (also known as ESO 350-40 or PGC 2248) is a lenticular galaxy and ring galaxy about 500 million light-years away in the constellation Sculptor. It is an estimated 150,000 light-years diameter, and has a mass of about 2.9–4.8 × 109 solar masses; its outer ring has a circular velocity of 217 km/s.It was discovered by Fritz Zwicky in 1941. Zwicky considered his discovery to be \"one of the most complicated structures awaiting its explanation on the basis of stellar dynamics.\"An estimation of the galaxy's span resulted in a conclusion of 150,000 light years, which is a moderate amount smaller than the Milky Way.The large Cartwheel galaxy is the dominant member of the Cartwheel galaxy group, which consists of four physically associated spiral galaxies. The three companions are referred to in several studies as G1 - the smaller irregular blue Magellanic spiral, G2 - the yellow compact spiral with a tidal tail, and G3 - a more distant spiral often seen in wide field images.\nSN 2021afdx, a type II supernova in the Cartwheel galaxy, was discovered in November 2021.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "Messier 82",
    "name": "Cigar Galaxy",
    "type": "Starburst Galaxy",
    "constellation": "Ursa Major",
    "magnitude": 8.4,
    "credit": "NASA/ESA/Hubble",
    "img": 133,
    "ra": {
      "decimal": 148.9684583,
      "h": 9,
      "m": 55,
      "s": 52
    },
    "dec": {
      "decimal": 69.6797028,
      "d": 69,
      "m": 40,
      "s": 47
    },
    "description": "Messier 82 (also known as NGC 3034, Cigar Galaxy or M82) is a starburst galaxy approximately 12 million light-years away in the constellation Ursa Major. A member of the M81 Group, it is about five times more luminous than the Milky Way and has a center one hundred times more luminous. The starburst activity is thought to have been triggered by interaction with neighboring galaxy M81.  As the closest starburst galaxy to Earth, M82 is the prototypical example of this galaxy type. SN 2014J, a type Ia supernova, was discovered in the galaxy on 21 January 2014. In 2014, in studying M82, scientists discovered the brightest pulsar yet known, designated M82 X-2.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "Messier 77",
    "name": "Squid Galaxy",
    "type": "Spiral Galaxy",
    "constellation": "Cetus",
    "magnitude": 9.6,
    "credit": "Adam Block/Mount Lemmon SkyCenter/University of Arizona",
    "img": 134,
    "ra": {
      "decimal": 40.6698792,
      "h": 2,
      "m": 42,
      "s": 40
    },
    "dec": {
      "decimal": 0.0132889,
      "d": "-00",
      "m": 0,
      "s": 48
    },
    "description": "Messier 77 or M77, also known as NGC 1068 and the Squid Galaxy, is a barred spiral galaxy about 47 million light-years away in the constellation Cetus. Messier 77 was discovered by Pierre Méchain in 1780, who originally described it as a nebula.  Méchain then communicated his discovery to Charles Messier, who subsequently listed the object in his catalog. Both Messier and William Herschel described this galaxy as a star cluster. Today, however, the object is known to be a galaxy.\nThe morphological classification of NGC 1068 in the De Vaucouleurs system is (R)SA(rs)b, where the '(R)' indicates an outer ring-like structure, 'SA' denotes a non-barred spiral, '(rs)' means a transitional inner ring/spiral structure, and 'b' says the spiral arms are moderately wound. Ann et al. (2015) gave it a class of SAa, suggesting tightly wound arms. However, infrared images of the inner part of the galaxy reveal a prominent bar not seen in visual light, and for this reason it is now considered a barred spiral.Messier 77 is an active galaxy with an Active Galactic Nucleus (AGN), which is obscured from view by astronomical dust at visible wavelengths. The diameter of the molecular disk and hot plasma associated with the obscuring material was first measured at radio wavelengths by the VLBA and VLA. The hot dust around the nucleus was subsequently measured in the mid-infrared by the MIDI instrument at the VLTI. It is the brightest and one of the closest and best-studied type 2 Seyfert galaxies, forming a prototype of this class.\n\nX-ray source 1H 0244+001 in Cetus has been identified as Messier 77. Only one supernova has been detected in Messier 77. The supernova, named SN 2018ivc, was discovered on 24 November 2018 by the DLT40 Survey. It is a type II supernova, and at discovery it was 15th magnitude and brightening.In February 2022 The European Southern Observatory found a cloud of cosmic dust at the centre of Messier 77 hiding a supermassive black hole.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "ESO 97-G13",
    "name": "Circinus Galaxy",
    "type": "Spiral Galaxy",
    "constellation": "Circinus",
    "magnitude": 12.1,
    "credit": "Judy Schmidt",
    "img": 135,
    "ra": {
      "decimal": 213.291275,
      "h": 14,
      "m": 13,
      "s": 9.906
    },
    "dec": {
      "decimal": -65.33901944444445,
      "d": -65,
      "m": 20,
      "s": 20.47
    },
    "description": "The Circinus Galaxy (ESO 97-G13) is a Seyfert galaxy in the constellation of Circinus.  It is located 4 degrees below the Galactic plane, and, at a distance of 4.0 Mpc (13 Mly), is one of the closest major galaxies to the Milky Way. The galaxy is undergoing tumultuous changes, as rings of gas are likely being ejected from the galaxy. Its outermost ring is 1400 light-years across while the inner ring is 260 light-years across.  Although the Circinus galaxy can be seen using a small telescope, it was not noticed until 1977 because it lies close to the plane of the Milky Way and is obscured by galactic dust.  The Circinus Galaxy is a Type II Seyfert galaxy and is one of the closest known active galaxies to the Milky Way, though it is probably slightly farther away than Centaurus A.\nCircinus Galaxy produced supernova SN 1996cr, which was identified over a decade after it exploded. This supernova event was first observed during 2001 as a bright, variable object in a Chandra X-ray Observatory image, but it was not confirmed as a supernova until years later.\nThe Circinus Galaxy is one of twelve large galaxies in the \"Council of Giants\" surrounding the Local Group in the Local Sheet. One object is possibly a satellite of the Circinus Galaxy, known as HIZOA J1353-58. HIZOA J1353-58 was discovered in a survey of neutral hydrogen (H I) and is located within the Zone of Avoidance.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "3C 405",
    "name": "Cygnus A",
    "type": "Elliptical Galaxy",
    "constellation": "Cygnus",
    "magnitude": 16.22,
    "credit": "NASA/CXC/SAO; NASA/STScI; NSF/NRAO/AUI/VLA",
    "img": 136,
    "ra": {
      "decimal": 299.86815190954167,
      "h": 19,
      "m": 59,
      "s": 28.35645829
    },
    "dec": {
      "decimal": 40.733915736,
      "d": 40,
      "m": 44,
      "s": 2.0966496
    },
    "description": "Cygnus A (3C 405) is a radio galaxy, and one of the strongest radio sources in the sky. A concentrated radio source in Cygnus was discovered by Grote Reber in 1939. In 1946 Stanley Hey and his colleague James Phillips identified that the source scintillated rapidly, and must therefore be a compact object. In 1951, Cygnus A, along with Cassiopeia A, and Puppis A were the first \"radio stars\" identified with an optical source. Of these, Cygnus A became the first radio galaxy, the other two being nebulae inside the Milky Way. In 1953 Roger Jennison and M K Das Gupta showed it to be a double source. Like all radio galaxies, it contains an active galactic nucleus. The supermassive black hole at the core has a mass of (2.5±0.7)×109 M☉.Images of the galaxy in the radio portion of the electromagnetic spectrum show two jets protruding in opposite directions from the galaxy's center. These jets extend many times the width of the portion of the host galaxy which emits radiation at visible wavelengths. At the ends of the jets are two lobes with \"hot spots\" of more intense radiation at their edges. These hot spots are formed when material from the jets collides with the surrounding intergalactic medium.In 2016, a radio transient was discovered 460 parsecs away from the center of Cygnus A. Between 1989 and 2016, the object, cospatial with a previously-known infrared source, exhibited at least an eightfold increase in radio flux density, with comparable luminosity to the brightest known supernova. Due to the lack of measurements in the intervening years, the rate of brightening is unknown, but the object has remained at a relatively constant flux density since its discovery. The data are consistent with a second supermassive black hole orbiting the primary object, with the secondary having undergone a rapid accretion rate increase. The inferred orbital timescale is of the same order as the activity of the primary source, suggesting the secondary may be perturbing the primary and causing the outflows.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 6946",
    "name": "Fireworks Galaxy",
    "type": "Spiral Galaxy",
    "constellation": "Cepheus",
    "magnitude": 9.6,
    "credit": "NASA",
    "img": 137,
    "ra": {
      "decimal": 308.71666666666664,
      "h": 20,
      "m": 34,
      "s": 52
    },
    "dec": {
      "decimal": 60.15361111111111,
      "d": 60,
      "m": 9,
      "s": 13
    },
    "description": "NGC 6946, sometimes referred to as the Fireworks Galaxy, is a face-on intermediate spiral galaxy with a small bright nucleus, whose location in the sky straddles the boundary between the northern constellations of Cepheus and Cygnus. Its distance from Earth is about 25.2 million light-years or 7.72 megaparsecs, similar to the distance of M101 (NGC 5457) in the constellation Ursa Major.  Both were once considered to be part of the Local Group, but are now known to be among the dozen bright spiral galaxies near the Milky Way but beyond the confines of the Local Group. NGC 6946 lies within the Virgo Supercluster.Discovered by William Herschel on 9 September 1798, this well-studied galaxy has a diameter of approximately 40,000 light-years\n, about one-third of the Milky Way's size, and it contains roughly half the number of stars as the Milky Way. It is heavily obscured by interstellar matter due to its location close to the galactic plane of the Milky Way.  Due to its prodigious star formation it has been classified as an active starburst galaxy.Various unusual celestial objects have been observed within NGC 6946. This includes the so-called 'Red Ellipse' along one of the northern arms that looks like a super-bubble or very large supernova remnant, and which may have been formed by an open cluster containing massive stars. There are also two regions of unusual dark lanes of nebulosity, while within the spiral arms several regions appear devoid of stars and gaseous hydrogen, some spanning up to two kiloparsecs across. A third peculiar object, discovered in 1967, is now known as \"Hodge's Complex\". This was once thought to be a young supergiant cluster, but in 2017 it was conjectured to be an interacting dwarf galaxy superimposed on NGC 6946.\n\n",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 224",
    "name": "Andromeda Galaxy",
    "type": "Spiral Galaxy",
    "constellation": "Andromeda",
    "magnitude": 3.4,
    "credit": "Public Domain",
    "img": 138,
    "ra": {
      "decimal": 10.6847083,
      "h": 0,
      "m": 42,
      "s": 44
    },
    "dec": {
      "decimal": 41.26875,
      "d": 41,
      "m": 16,
      "s": 9
    },
    "description": "The Andromeda Galaxy (IPA: ), also known as Messier 31, M31, or NGC 224 and originally the Andromeda Nebula (see below), is a barred spiral galaxy with diameter of about 220,000 ly approximately 2.5 million light-years (770 kiloparsecs) from Earth and the nearest large galaxy to the Milky Way. The galaxy's name stems from the area of Earth's sky in which it appears, the constellation of Andromeda, which itself is named after the Ethiopian (or Phoenician) princess who was the wife of Perseus in Greek mythology.\nThe virial mass of the Andromeda Galaxy is of the same order of magnitude as that of the Milky Way, at 1 trillion solar masses (2.0×1042 kilograms). The mass of either galaxy is difficult to estimate with any accuracy, but it was long thought that the Andromeda Galaxy is more massive than the Milky Way by a margin of some 25% to 50%. This has been called into question by a 2018 study that cited a lower estimate on the mass of the Andromeda Galaxy,\ncombined with preliminary reports on a 2019 study estimating a higher mass of the Milky Way. The Andromeda Galaxy has a diameter of about 220,000 ly (67 kpc), making it the largest member of the Local Group in terms of extension.\nThe Milky Way and Andromeda galaxies are expected to collide in around 4-5 billion years, merging to form a giant elliptical galaxy or a large lenticular galaxy.\nWith an apparent magnitude of 3.4, the Andromeda Galaxy is among the brightest of the Messier objects, making it visible to the naked eye from Earth on moonless nights, even when viewed from areas with moderate light pollution.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 598",
    "name": "Triangulum Galaxy",
    "type": "Spiral Galaxy",
    "constellation": "Triangulum",
    "magnitude": 5.7,
    "credit": "NASA/CXC/SAO/P. Plucinsky et al.",
    "img": 139,
    "ra": {
      "decimal": 23.4621,
      "h": 1,
      "m": 33,
      "s": 50
    },
    "dec": {
      "decimal": 30.6599417,
      "d": 30,
      "m": 39,
      "s": 36
    },
    "description": "The Triangulum Galaxy is a spiral galaxy 2.73 million light-years (ly) from Earth in the constellation Triangulum. It is catalogued as Messier 33 or NGC 598. The Triangulum Galaxy is the third-largest member of the Local Group of galaxies, behind the Andromeda Galaxy and the Milky Way. It is one of the most distant permanent objects that can be viewed with the naked eye.The galaxy is the smallest spiral galaxy in the Local Group (although the smaller Large and Small Magellanic Clouds may have been spirals before their encounters with the Milky Way), and is believed to be a satellite of the Andromeda Galaxy or on its rebound into the latter due to their interactions, velocities, and proximity to one another in the night sky. It also has an H II nucleus.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "Messier 74",
    "name": "Phantom Galaxy",
    "type": "Spiral Galaxy",
    "constellation": "Pisces",
    "magnitude": 10,
    "credit": "NASA/ESA/Hubble",
    "img": 140,
    "ra": {
      "decimal": 24.17405,
      "h": 1,
      "m": 36,
      "s": 41
    },
    "dec": {
      "decimal": 15.7834611,
      "d": 15,
      "m": 47,
      "s": 1
    },
    "description": "Messier 74 (also known as NGC 628 and Phantom Galaxy) is a large spiral galaxy in the equatorial constellation Pisces. It is about 32 million light-years away from Earth. The galaxy contains two clearly defined spiral arms and is therefore used as an archetypal example of a grand design spiral galaxy.  The galaxy's low surface brightness makes it the most difficult Messier object for amateur astronomers to observe.  Its relatively large angular (that is, apparent) size and the galaxy's face-on orientation make it an ideal object for professional astronomers who want to study spiral arm structure and spiral density waves. It is estimated that M74 hosts about 100 billion stars.\n\n",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "Messier 83",
    "name": "Southern Pinwheel Galaxy",
    "type": "Barred Spiral Galaxy",
    "constellation": "Hydra",
    "magnitude": 7.6,
    "credit": "NASA/ESA/Hubble",
    "img": 141,
    "ra": {
      "decimal": 204.25382916666666,
      "h": 13,
      "m": 37,
      "s": 0.919
    },
    "dec": {
      "decimal": -29.865761111111112,
      "d": -29,
      "m": 51,
      "s": 56.74
    },
    "description": "Messier 83 or M83, also known as the Southern Pinwheel Galaxy and NGC 5236, is a barred spiral galaxy approximately 15 million light-years away in the constellation borders of Hydra and Centaurus. Nicolas-Louis de Lacaille discovered M83 on 23 February 1752 at the Cape of Good Hope. Charles Messier added it to his catalogue of nebulous objects (now known as the Messier Catalogue) in March 1781. It is one of the closest and brightest barred spiral galaxies in the sky, and is visible with binoculars. Its nickname of the Southern Pinwheel derives from its resemblance to the Pinwheel Galaxy (M101).\n\n",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "Messier 94",
    "name": "Cat's Eye Galaxy",
    "type": "Spiral Galaxy",
    "constellation": "Canes Venatici",
    "magnitude": 9,
    "credit": "NASA/ESA/Hubble",
    "img": 142,
    "ra": {
      "decimal": 192.72145,
      "h": 12,
      "m": 50,
      "s": 53
    },
    "dec": {
      "decimal": 41.1201528,
      "d": 41,
      "m": 7,
      "s": 14
    },
    "description": "Messier 94 (also known as NGC 4736) is a spiral galaxy in the mid-northern constellation Canes Venatici.  It was discovered by Pierre Méchain in 1781,\nand catalogued by Charles Messier two days later.  Although some references describe M94 as a barred spiral galaxy, the \"bar\" structure appears to be more oval-shaped.  The galaxy has two ring structures.\n\n",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 5866",
    "name": "Spindle Galaxy",
    "type": "Lenticular Galaxy",
    "constellation": "Draco",
    "magnitude": 10.7,
    "credit": "NASA/ESA/Hubble",
    "img": 143,
    "ra": {
      "decimal": 226.6231708,
      "h": 15,
      "m": 6,
      "s": 29
    },
    "dec": {
      "decimal": 55.7633083,
      "d": 55,
      "m": 45,
      "s": 48
    },
    "description": "NGC 5866 (also called the Spindle Galaxy or Messier 102) is a relatively bright lenticular galaxy in the constellation Draco. NGC 5866 was most likely discovered by Pierre Méchain or Charles Messier in 1781, and independently found by William Herschel in 1788.\nMeasured orbital velocities of its globular cluster system\nimply that dark matter makes up only 34±45% of the mass within 5 effective radii;\na notable paucity.\n\n",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "IC 342",
    "name": "Hidden Galaxy",
    "type": "Spiral Galaxy",
    "constellation": "Camelopardalis",
    "magnitude": 9,
    "credit": "NASA/ESA/Hubble",
    "img": 144,
    "ra": {
      "decimal": 56.7,
      "h": 3,
      "m": 46,
      "s": 48
    },
    "dec": {
      "decimal": 68.09583333333333,
      "d": 68,
      "m": 5,
      "s": 45
    },
    "description": "IC 342 (also known as Caldwell 5) is an intermediate spiral galaxy in the constellation Camelopardalis, located relatively close to the Milky Way. Despite its size and actual brightness, its location behind dusty areas near the galactic equator makes it difficult to observe, leading to the nickname \"The Hidden Galaxy\", though it can readily be detected even with binoculars. If the galaxy were not obscured, it would be visible by naked eye. The dust makes it difficult to determine its precise distance; modern estimates range from about 7 Mly to about 11 Mly.\nThe galaxy was discovered by William Frederick Denning in 1892. It is one of the brightest in the IC 342/Maffei Group, one of the closest galaxy groups to the Local Group. Edwin Hubble first thought it to be in the Local Group, but it was later determined not to be a member.In 1935, Harlow Shapley found that it was wider than the full moon, and by angular size the third-largest spiral galaxy then known, smaller only than the Andromeda Galaxy (M31) and the Triangulum Galaxy (M33). (Modern estimates are more conservative, giving the apparent size as one-half to two-thirds the diameter of the full moon).It has an H II nucleus. The galaxy has a diameter of 75 000 light-years.In 2020, the galaxy KKH 32 was identified as the first known satellite of IC 342 that is a dwarf spheroidal galaxy. Unlike galaxies with large bulges such as the Andromeda Galaxy, IC 342 has a relatively few dwarf satellite galaxies. KKH 32 is located about 10.2 million light-years (3.12 megaparsecs) away, and has a diameter of about 4,300 light-years (1.32 kiloparsecs).",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 891",
    "name": "Silver Sliver Galaxy",
    "type": "Spiral Galaxy",
    "constellation": "Andromeda",
    "magnitude": 10,
    "credit": "Adam Block/Mount Lemmon SkyCenter/University of Arizona",
    "img": 145,
    "ra": {
      "decimal": 35.63333333333333,
      "h": 2,
      "m": 22,
      "s": 32
    },
    "dec": {
      "decimal": 42.34805555555556,
      "d": 42,
      "m": 20,
      "s": 53
    },
    "description": "▪︎\nNGC 891 (also known as Caldwell 23, the Silver Sliver Galaxy, and the Outer Limits Galaxy) is an edge-on unbarred spiral galaxy about 30 million light-years away in the constellation Andromeda. It was discovered by William Herschel on October 6, 1784. The galaxy is a member of the NGC 1023 group of galaxies in the Local Supercluster. It has an H II nucleus.The object is visible in small to moderate size telescopes as a faint elongated smear of light with a dust lane visible in larger apertures.\nIn 1999, the Hubble Space Telescope imaged NGC 891 in infrared.\nIn 2005, due to its attractiveness and scientific interest, NGC 891 was selected to be the first light image of the Large Binocular Telescope.\nIn 2012, it was again used as a first light image of the Lowell Discovery Telescope with the Large Monolithic Imager.Supernova SN 1986J was discovered on August 21, 1986 at apparent magnitude 14.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 4631",
    "name": "Whale Galaxy",
    "type": "Barred Spiral Galaxy",
    "constellation": "Canes Venatici",
    "magnitude": 9.3,
    "credit": "Adam Block/Mount Lemmon SkyCenter/University of Arizona",
    "img": 146,
    "ra": {
      "decimal": 190.53333333333333,
      "h": 12,
      "m": 42,
      "s": 8
    },
    "dec": {
      "decimal": 32.54138888888889,
      "d": 32,
      "m": 32,
      "s": 29
    },
    "description": "NGC 4631 (also known as the Whale Galaxy or Caldwell 32) is a  barred spiral galaxy in the constellation Canes Venatici.  This galaxy's slightly distorted wedge shape gives it the appearance of a herring or a whale, hence its nickname.  Because this nearby galaxy is seen edge-on from Earth, professional astronomers observe this galaxy to better understand the gas and stars located outside the plane of the galaxy.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 4565",
    "name": "Needle Galaxy",
    "type": "Spiral Galaxy",
    "constellation": "Coma Berenices",
    "magnitude": 9.6,
    "credit": "Ken Crawford",
    "img": 147,
    "ra": {
      "decimal": 189.08333333333334,
      "h": 12,
      "m": 36,
      "s": 20
    },
    "dec": {
      "decimal": 25.987222222222222,
      "d": 25,
      "m": 59,
      "s": 14
    },
    "description": "NGC 4565 (also known as the Needle Galaxy or Caldwell 38) is an edge-on spiral galaxy about 30 to 50 million light-years away in the constellation Coma Berenices. It lies close to the North Galactic Pole and has a visual magnitude of approximately 10.  It is known as the Needle Galaxy for its narrow profile. First recorded in 1785 by William Herschel, it is a prominent example of an edge-on spiral galaxy.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "NGC 4656, NGC 4657",
    "name": "Hockey Stick Galaxy",
    "type": "Barred Spiral Galaxy",
    "constellation": "Canes Venatici",
    "magnitude": 11,
    "credit": "T.A. Rector (University of Alaska Anchorage) and H. Schweiker (WIYN and NOIRLab/NSF/AURA)",
    "img": 148,
    "ra": {
      "decimal": 190.99037045407,
      "h": 12,
      "m": 43,
      "s": 57.6889089768
    },
    "dec": {
      "decimal": 32.17037386514,
      "d": 32,
      "m": 10,
      "s": 13.345914504
    },
    "description": "NGC 4656/57 is a highly warped barred spiral galaxy located in the constellation Canes Venatici and is sometimes informally called the Hockey Stick Galaxies or the Crowbar Galaxy. Its unusual shape is thought to be due to an interaction between NGC 4656, NGC 4631, and NGC 4627. The galaxy is a member of the NGC 4631 Group. A Luminous Blue Variable in \"super-outburst\" was discovered in NGC 4656/57 on March 21, 2005.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "AM 0644-741",
    "name": "Lindsay-Shapley Ring",
    "type": "Lenticular Galaxy",
    "constellation": "Volans",
    "magnitude": 13.98,
    "credit": "NASA/ESA/Hubble",
    "img": 149,
    "ra": {
      "decimal": 100.77528483219,
      "h": 6,
      "m": 43,
      "s": 6.0683597256
    },
    "dec": {
      "decimal": -74.23628667703,
      "d": -74,
      "m": 14,
      "s": 10.632037308
    },
    "description": "AM 0644-741, also known as the Lindsay-Shapley Ring, is an unbarred lenticular galaxy, and a ring galaxy, which is 300 million light-years away in the southern constellation Volans.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "Sh2-308",
    "name": "Dolphin Nebula",
    "type": "Emission Nebula",
    "constellation": "Canis Major",
    "magnitude": 7.0,
    "credit": "Jim DeLilo",
    "img": 150,
    "ra": {
      "decimal": 103.55434983683,
      "h": 6,
      "m": 54,
      "s": 13.0439608392
    },
    "dec": {
      "decimal": -23.92833981107,
      "d": -23,
      "m": 55,
      "s": 42.023319852
    },
    "description": "Sh2-308, also designated as Sharpless 308, RCW 11, or LBN 1052, is an H II region located near the center of the constellation Canis Major, composed of ionised hydrogen. It is about 8 degrees south of Sirius, the brightest star in the night sky. The nebula is bubble-like and surrounds a Wolf–Rayet star named EZ Canis Majoris. This star is in the brief, pre-supernova phase of its stellar evolution. The nebula is about 4,530 light-years (1,389 parsecs) away from Earth, but some sources indicate that both the star and the nebula are up to 5,870 ly (1,800 pc) away. Yet others indicate the nebula is as close as 1,875 ly (575 pc) from Earth.",
    "desccred": "https://en.wikipedia.org/"
  },
  {
    "label": "3C 348",
    "name": "Hercules A",
    "type": "Elliptical Galaxy",
    "constellation": "Hercules",
    "magnitude": 18.25,
    "credit": "NASA/ESA/Hubble",
    "img": 151,
    "ra": {
      "decimal": 252.78328611991,
      "h": 16,
      "m": 51,
      "s": 7.9886687784
    },
    "dec": {
      "decimal": 4.99320753652,
      "d": +4,
      "m": 59,
      "s": 35.547131472
    },
    "description": "Hercules A is a bright astronomical radio source within the vicinity of the constellation Hercules corresponding to the galaxy 3C 348.",
    "desccred": "https://en.wikipedia.org/"
  }
]
